/*
 * MagNano V2 PDP behavior.
 * Liquid-generated runtime values are supplied by data attributes on #magnano-v2.
 */
  (function () {
    'use strict';

    var MAX_PACK_COUNT = 7;

    var LID_MODES = ['NONE', 'DOTW', 'CUSTOM'];
    var DOTW_ORDER = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    var LID_CUSTOM_MAX_LEN = 3;

    var POCKET_MODES_BY_COUNT = {
      1: ['NONE', 'DOTW', 'CUSTOM'],
      2: ['NONE', 'AMPM', 'DOTW_AMPM']
    };
    var POCKET_DEFAULT_MODE_BY_COUNT = { 1: 'DOTW', 2: 'AMPM' };
    var POCKET_DAY_MODES = ['DOTW', 'DOTW_AMPM'];
    var POCKET_MAX_LEN = 3;
    var LID_MODE_FALLBACK_PRICE_CENTS = { DOTW: 1500, CUSTOM: 2000 };
    var POCKET_MODE_FALLBACK_PRICE_CENTS = { DOTW: 1500, CUSTOM: 1500, AMPM: 1500, DOTW_AMPM: 1500 };

    var section = document.getElementById('magnano-v2');
    if (!section) return;
    var SECTION_ID = section.getAttribute('data-section-id') || '';
    var caseImagesByColor = readInlineJson('case-images-json-' + SECTION_ID) || {};
    var PREORDER_ETA_TEXT = section.getAttribute('data-preorder-eta-text') || 'Ships by mid-July';

    var atcBtn = section.querySelector('[data-atc]');
    var atcErrorEl = section.querySelector('[data-atc-error]');
    var currentHandle = section.getAttribute('data-current-handle');
    var listingContext = section.getAttribute('data-listing-context') || '';

    function hasMatchingListingContext(payload) {
      return !!payload && payload.listing_context === listingContext;
    }

    var pdpTitleEl    = section.querySelector('[data-pdp-title]');
    var pdpTitleDefault = pdpTitleEl ? pdpTitleEl.textContent : '';
    var pdpReviewsEl = section.querySelector('[data-pdp-reviews]');
    var pdpReviewTemplatesEl = section.querySelector('[data-pdp-review-templates]');
    var priceBlockEl  = section.querySelector('[data-pdp-price]');
    var pricePromptEl = priceBlockEl && priceBlockEl.querySelector('[data-price-prompt]');
    var priceFigureEl = priceBlockEl && priceBlockEl.querySelector('[data-price-figure]');
    var priceTotalEl  = priceBlockEl && priceBlockEl.querySelector('[data-price-total]');
    var stockPillEl   = section.querySelector('[data-stock-pill]');
    var stockLabelEl  = stockPillEl && stockPillEl.querySelector('[data-stock-label]');
    var stockEtaEl    = section.querySelector('[data-stock-eta]');
    var notifyModalEl = section.querySelector('[data-notify-modal]');
    var notifyFormEl = section.querySelector('[data-notify-form]');
    var notifyPocketSelect = section.querySelector('[data-notify-pocket-count]');
    var notifySizeSelect = section.querySelector('[data-notify-size]');
    var notifyColorSelect = section.querySelector('[data-notify-color]');
    var notifyEmailInput = section.querySelector('[data-notify-email]');
    var notifyMessageEl = section.querySelector('[data-notify-message]');
    var notifySubmitBtn = section.querySelector('[data-notify-submit]');
    var notifyContextEl = section.querySelector('[data-notify-context]');
    var notifyProductInput = section.querySelector('[data-notify-product]');
    var notifyVariantLabelInput = section.querySelector('[data-notify-variant-label]');
    var notifyPocketCountInput = section.querySelector('[data-notify-pocket-count-value]');
    var notifyCaseSizeInput = section.querySelector('[data-notify-case-size-value]');
    var notifyFirstColorInput = section.querySelector('[data-notify-first-color]');
    var notifyDateInput = section.querySelector('[data-notify-date]');
    var NOTIFY_ENDPOINT = 'https://script.google.com/macros/s/AKfycbxmSIHmqUAYAX_3xFOZRzjvnzAZGrmCOmyvQkvcxZwvTH8uvIQJ83NCNFgIieZ-7-jP8Q/exec';

    var galleryEl       = section.querySelector('[data-pdp-gallery]');
    var galleryStageEl  = galleryEl && galleryEl.querySelector('[data-gallery-stage]');
    var galleryThumbsEl = galleryEl && galleryEl.querySelector('[data-gallery-thumbs]');
    var galleryPrevBtn  = galleryEl && galleryEl.querySelector('[data-gallery-prev]');
    var galleryNextBtn  = galleryEl && galleryEl.querySelector('[data-gallery-next]');

    var specAccordionEl = section.querySelector('[data-magnano-case-specs]');
    var specPanelEls    = specAccordionEl ? specAccordionEl.querySelectorAll('[data-magnano-case-spec-panel]') : [];
    var specSizePocketCount = 0;

    var compositePreviewEls = section.querySelectorAll('[data-composite-preview]');
    var activeSlideIndex = 0;
    var galleryProductHandle = '';
    var galleryPocketCount = 0;
    var gallerySizeKey = '';
    var galleryFirstSlideMode = '';

    var tierProduct, dispatchList, lidProduct, pocketProduct, travelProduct;

    var pickerState = {
      expandedStep: '1',
      touchedSteps: { '1': false, '2': false, '3': false, '4': false, '5': false, '6': false, '7': false },
      pocketCount: 1,
      dispatchEntry: null,
      urlPrefill: null,
      size: null,
      packCount: 0,
      colorAllocation: [],
      lidEngraving: { mode: null, labels: [] },
      pocketEngraving: { mode: null, labels: [], dotwSync: true },
      travelBox: { selected: false, variantId: null, skippedUnavailable: false }
    };

    var cartReservedByVariantId = {};
    var cartReservationsPromise = null;
    var cartReservationsLoaded = false;

    var caseProduct = null;
    var sizeStep = window.theme && window.theme.sizeStep;
    var sizeCapacityBar = null;
    var notifyProductsByPocketCount = {};
    var notifyProductFetchToken = 0;
    var lidVariant = null;
    var pocketVariant = null;
    var travelVariant = null;
    var currentTooltip = null;
    var currentTooltipTrigger = null;
    var detailsCurrentPage = null;
    var detailsRequestedPage = null;
    var detailsFetchToken = 0;
    var detailsInitialStateHandled = false;
    var urlPrefillRun = 0;

    function setPdpTitle(title) {
      if (!pdpTitleEl) return;
      var next = (title && String(title).trim()) || pdpTitleDefault;
      if (pdpTitleEl.textContent !== next) pdpTitleEl.textContent = next;
    }

    function refreshPdpReviewWidgets() {
      window.setTimeout(function () {
        if (window.jdgm) {
          if (typeof window.jdgm.initializeBadges === 'function') window.jdgm.initializeBadges();
          if (typeof window.jdgm.customizeBadges === 'function') window.jdgm.customizeBadges();
          if (typeof window.jdgm.refreshWidgets === 'function') window.jdgm.refreshWidgets();
        }
        if (window.Loox && typeof window.Loox.refresh === 'function') window.Loox.refresh();
        if (window.SPR && typeof window.SPR.initDomEls === 'function') window.SPR.initDomEls();
      }, 0);
    }

    function hidePdpReviews() {
      if (!pdpReviewsEl) return;
      pdpReviewsEl.innerHTML = '';
      pdpReviewsEl.setAttribute('aria-hidden', 'true');
    }

    function setPdpReviews(pocketCount) {
      if (!pdpReviewsEl || !pdpReviewTemplatesEl) return;
      var pc = parseInt(pocketCount, 10) || 0;
      if (!pc) {
        hidePdpReviews();
        return;
      }
      var template = pdpReviewTemplatesEl.querySelector('[data-pocket-review-template="' + pc + '"]');
      if (!template) {
        hidePdpReviews();
        return;
      }
      pdpReviewsEl.innerHTML = template.innerHTML;
      pdpReviewsEl.removeAttribute('aria-hidden');
      refreshPdpReviewWidgets();
    }

    function getConfiguratorShopifySection() {
      return section.closest('.shopify-section');
    }

    function getDetailsSection() {
      var host = getConfiguratorShopifySection();
      if (!host) return null;
      var sibling = host.nextElementSibling;
      while (sibling && (!sibling.classList || !sibling.classList.contains('shopify-section'))) {
        sibling = sibling.nextElementSibling;
      }
      return sibling || null;
    }

    function extractDetailsSectionFromHtml(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var container = doc.querySelector('#PageContainer') || doc.body;
      if (!container) return null;

      for (var i = 0; i < container.children.length; i++) {
        var child = container.children[i];
        if (child.classList && child.classList.contains('shopify-section') && !child.querySelector('#magnano-v2')) {
          return child;
        }
      }

      var sections = container.querySelectorAll('.shopify-section');
      for (var j = 0; j < sections.length; j++) {
        if (!sections[j].querySelector('#magnano-v2')) return sections[j];
      }
      return null;
    }

    function activateInsertedScripts(container) {
      var scripts = container.querySelectorAll('script');
      for (var i = 0; i < scripts.length; i++) {
        var source = scripts[i];
        var replacement = document.createElement('script');
        for (var j = 0; j < source.attributes.length; j++) {
          var attr = source.attributes[j];
          replacement.setAttribute(attr.name, attr.value);
        }
        replacement.text = source.text || source.textContent || '';
        source.parentNode.replaceChild(replacement, source);
      }
    }

    function markDetailsSection(detailsSection, pageHandle) {
      if (!detailsSection) return;
      detailsSection.setAttribute('data-magnano-v2-dynamic-details', '');
      detailsSection.setAttribute('data-magnano-v2-details-page', pageHandle);
    }

    function replaceDetailsSection(nextSection, pageHandle) {
      var host = getConfiguratorShopifySection();
      if (!host || !nextSection) return false;

      nextSection = nextSection.cloneNode(true);
      markDetailsSection(nextSection, pageHandle);

      var currentDetails = getDetailsSection();
      if (currentDetails) {
        currentDetails.replaceWith(nextSection);
      } else {
        host.insertAdjacentElement('afterend', nextSection);
      }

      activateInsertedScripts(nextSection);
      detailsCurrentPage = pageHandle;
      detailsRequestedPage = null;
      document.dispatchEvent(new CustomEvent('magnano-v2:details-loaded', {
        detail: { page: pageHandle }
      }));
      return true;
    }

    function fetchDetailsPage(pageHandle, token, urls, index) {
      if (token !== detailsFetchToken) return;
      var url = urls[index || 0];
      if (!url) {
        if (detailsRequestedPage === pageHandle) detailsRequestedPage = null;
        console.warn('[magnano-v2] No details page found for "' + pageHandle + '".');
        return;
      }

      fetch(url, { headers: { 'Accept': 'text/html' } })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          if (token !== detailsFetchToken) return;
          var nextSection = extractDetailsSectionFromHtml(html);
          if (!nextSection) {
            fetchDetailsPage(pageHandle, token, urls, (index || 0) + 1);
            return;
          }
          if (!replaceDetailsSection(nextSection, pageHandle)) {
            console.warn('[magnano-v2] Could not replace details section for "' + pageHandle + '".');
          }
        })
        .catch(function (err) {
          if (token !== detailsFetchToken) return;
          if ((index || 0) + 1 < urls.length) {
            fetchDetailsPage(pageHandle, token, urls, (index || 0) + 1);
            return;
          }
          if (detailsRequestedPage === pageHandle) detailsRequestedPage = null;
          console.warn('[magnano-v2] Failed to load details page "' + pageHandle + '":', err);
        });
    }

    function getDispatchProductHandle(dispatchEntry) {
      return dispatchEntry && dispatchEntry.handle ? String(dispatchEntry.handle).trim() : '';
    }

    function getDetailsPageHandle(dispatchEntry, size) {
      var productHandle = getDispatchProductHandle(dispatchEntry);
      var pocketCount = parseInt(dispatchEntry && dispatchEntry.pocketCount, 10) || 0;
      // Vitamin gets its own Replo details page per pocket count; every other
      // size falls back to the dispatch product's page.
      if (getAddonSizeKey(size) === 'vitamin') {
        if (pocketCount === 1) return 'magnano-vitamin-case';
        if (pocketCount === 2) return 'magnano-am-pm-vitamin-case';
      }
      return productHandle;
    }

    function syncDetailsSectionForDispatchEntry(dispatchEntry, size, options) {
      var pageHandle = getDetailsPageHandle(dispatchEntry, size);
      if (!pageHandle) return;

      if (options && options.initial && pageHandle === currentHandle && currentHandle.indexOf('am-pm') !== -1) {
        markDetailsSection(getDetailsSection(), pageHandle);
        detailsCurrentPage = pageHandle;
        detailsRequestedPage = null;
        return;
      }

      if (detailsCurrentPage === pageHandle || detailsRequestedPage === pageHandle) return;

      var token = ++detailsFetchToken;
      detailsRequestedPage = pageHandle;
      var sectionHandle = encodeURIComponent(pageHandle);
      fetchDetailsPage(pageHandle, token, [
        '/pages/combined-listings?view=' + sectionHandle
      ], 0);
    }

    function setNotifyMessage(text, tone) {
      if (!notifyMessageEl) return;
      notifyMessageEl.textContent = text || '';
      notifyMessageEl.classList.toggle('tw:hidden', !text);
      notifyMessageEl.classList.remove('tw:text-red-700', 'tw:text-green-700', 'tw:text-gray-600');
      if (!text) return;
      notifyMessageEl.classList.add(tone === 'success' ? 'tw:text-green-700' : (tone === 'error' ? 'tw:text-red-700' : 'tw:text-gray-600'));
    }

    function setNotifySubmitting(isSubmitting) {
      if (!notifySubmitBtn) return;
      notifySubmitBtn.disabled = !!isSubmitting;
      notifySubmitBtn.textContent = isSubmitting ? 'Sending...' : 'Notify me';
    }

    function replaceSelectOptions(select, options, placeholder, selectedValue) {
      if (!select) return;
      select.innerHTML = '';
      if (placeholder) {
        var placeholderOption = document.createElement('option');
        placeholderOption.value = '';
        placeholderOption.textContent = placeholder;
        placeholderOption.className = 'tw:text-gray-400';
        select.appendChild(placeholderOption);
      }
      options.forEach(function (option) {
        var opt = document.createElement('option');
        opt.value = option.value;
        opt.textContent = option.label;
        opt.className = 'tw:text-gray-900';
        if (selectedValue && option.value === selectedValue) opt.selected = true;
        select.appendChild(opt);
      });
      select.disabled = options.length === 0;
      updateSelectPromptVisual(select);
    }

    function updateSelectPromptVisual(select) {
      if (!select) return;
      var isPromptSelected = !select.value;
      select.classList.toggle('tw:text-gray-400', isPromptSelected);
      select.classList.toggle('tw:text-gray-900', !isPromptSelected);
    }

    function formatPocketCountLabel(pocketCount) {
      var pc = parseInt(pocketCount, 10) || 0;
      if (!pc) return '';
      return pc + '-Pocket' + (pc === 1 ? '' : 's');
    }

    function getNotifyPocketChoices() {
      var choices = [];
      var seen = {};
      (dispatchList || []).forEach(function (entry) {
        var pc = parseInt(entry && entry.pocketCount, 10) || 0;
        if (!pc || seen[pc] || !entry.handle || entry.status !== 'active') return;
        seen[pc] = true;
        choices.push({ value: String(pc), label: formatPocketCountLabel(pc) });
      });
      var selectedDispatchEntry = findDispatchEntry(pickerState.pocketCount);
      if (pickerState.pocketCount && !seen[pickerState.pocketCount] && selectedDispatchEntry && selectedDispatchEntry.handle && selectedDispatchEntry.status === 'active') {
        choices.push({ value: String(pickerState.pocketCount), label: formatPocketCountLabel(pickerState.pocketCount) });
      }
      return choices;
    }

    function getLoadedNotifyProduct(pocketCount) {
      var pc = parseInt(pocketCount, 10) || 0;
      if (!pc) return null;
      if (caseProduct && (parseInt(caseProduct.pocket_count, 10) || 1) === pc) return caseProduct;
      return notifyProductsByPocketCount[pc] || null;
    }

    function fetchNotifyProduct(pocketCount) {
      var pc = parseInt(pocketCount, 10) || 0;
      var loadedProduct = getLoadedNotifyProduct(pc);
      if (loadedProduct) return Promise.resolve(loadedProduct);
      var dispatchEntry = findDispatchEntry(pc);
      var fetcher = window.theme && window.theme.productDataFetcher;
      if (!dispatchEntry || !dispatchEntry.handle || !fetcher) return Promise.resolve(null);
      return fetcher.fetch('magnano', dispatchEntry.handle, pc, listingContext).then(function (data) {
        if (!data || data.error || !hasMatchingListingContext(data)) return null;
        notifyProductsByPocketCount[pc] = data;
        return data;
      });
    }

    function getNotifyColorChoices(product, sizeKey) {
      if (!product || !product.variants || !sizeKey) return [];
      var groups = {};
      var order = [];
      product.variants.forEach(function (variant) {
        if (!ciEquals(variant.option1, sizeKey)) return;
        var colorName = String(variant.option2 || '').trim();
        var colorKey = colorName.toLowerCase();
        if (!colorName) return;
        if (!groups[colorKey]) {
          groups[colorKey] = { value: colorName, label: colorName, hasSellableVariant: false, blocked: false };
          order.push(colorKey);
        }
        if (isVariantSellable(variant)) groups[colorKey].hasSellableVariant = true;
        if (variant.bis === false) groups[colorKey].blocked = true;
      });
      var choices = order.map(function (colorKey) {
        return groups[colorKey];
      }).filter(function (color) {
        return !color.hasSellableVariant && !color.blocked;
      }).map(function (color) {
        return { value: color.value, label: color.label };
      });
      (product.notify_colors || []).forEach(function (color) {
        if (!ciEquals(color.size_key, sizeKey)) return;
        var name = String(color.color_name || '').trim();
        var key = name.toLowerCase();
        if (!name || groups[key]) return;
        groups[key] = { value: name };
        choices.push({ value: name, label: name });
      });
      return choices;
    }

    function getNotifySizeChoices(product) {
      if (!product || !product.variants) return [];
      var variantSizeKeys = {};
      product.variants.forEach(function (variant) {
        var sizeKey = String(variant.option1 || '').trim();
        if (sizeKey) variantSizeKeys[sizeKey.toLowerCase()] = sizeKey;
      });
      var choices = [];
      if (product.sizes && product.sizes.length) {
        product.sizes.forEach(function (size) {
          if (getNotifyColorChoices(product, size.key).length) choices.push(size);
        });
      } else {
        Object.keys(variantSizeKeys).forEach(function (key) {
          var sizeKey = variantSizeKeys[key];
          if (getNotifyColorChoices(product, sizeKey).length) choices.push({ key: sizeKey, display_name: sizeKey });
        });
      }
      return choices;
    }

    function getNotifySizeLabel(sizeKey, product) {
      var key = String(sizeKey || '').trim();
      if (!key) return '';
      product = product || getLoadedNotifyProduct(notifyPocketSelect && notifyPocketSelect.value);
      var sizeData = product && product.sizes && product.sizes.find(function (size) { return ciEquals(size.key, key); });
      return (sizeData && (sizeData.display_name || sizeData.key)) || key;
    }

    function getNotifyCaseTypeLabel(sizeKey, product) {
      var sizeLabel = getNotifySizeLabel(sizeKey, product);
      var sizeText = [sizeKey, sizeLabel].join(' ');
      if (ciIncludes(sizeText, 'vitamin xl')) return 'Vitamin XL Case';
      if (ciIncludes(sizeText, 'vitamin')) return 'Vitamin Case';
      if (ciIncludes(sizeText, 'pill')) return 'Pill Case';
      return sizeLabel;
    }

    function getNotifyProductTitle(pocketCount, sizeKey) {
      var pc = parseInt(pocketCount, 10) || 0;
      var notifyProduct = getLoadedNotifyProduct(pc);
      var caseTypeLabel = getNotifyCaseTypeLabel(sizeKey, notifyProduct);
      var pocketLabel = pc === 2 ? 'AM-PM' : formatPocketCountLabel(pc);
      return pc ? ['MagNano', pocketLabel, caseTypeLabel].filter(Boolean).join(' ') : '';
    }

    function buildNotifyVariantLabel(pocketCount, sizeKey, color) {
      var pc = parseInt(pocketCount, 10) || 0;
      return [getNotifyProductTitle(pc, sizeKey), color].filter(Boolean).join(' / ');
    }

    function syncNotifyHiddenFields() {
      var pocketCount = notifyPocketSelect ? parseInt(notifyPocketSelect.value, 10) || 0 : 0;
      var size = notifySizeSelect ? notifySizeSelect.value : '';
      var color = notifyColorSelect ? notifyColorSelect.value : '';
      var notifyProduct = getLoadedNotifyProduct(pocketCount);
      var caseSizeLabel = getNotifyCaseTypeLabel(size, notifyProduct);
      var productLabel = getNotifyProductTitle(pocketCount, size);
      var variantLabel = buildNotifyVariantLabel(pocketCount, size, color);
      updateSelectPromptVisual(notifyPocketSelect);
      updateSelectPromptVisual(notifySizeSelect);
      updateSelectPromptVisual(notifyColorSelect);
      if (notifyProductInput) notifyProductInput.value = productLabel;
      if (notifyVariantLabelInput) notifyVariantLabelInput.value = variantLabel;
      if (notifyPocketCountInput) notifyPocketCountInput.value = pocketCount ? String(pocketCount) : '';
      if (notifyCaseSizeInput) notifyCaseSizeInput.value = caseSizeLabel;
      if (notifyFirstColorInput) notifyFirstColorInput.value = color;
      if (notifyContextEl) {
        notifyContextEl.textContent = productLabel && size && color
          ? 'We will email you when ' + variantLabel + ' is available.'
          : 'Select the design details you want us to track.';
      }
    }

    function refreshNotifyColorOptions(selectedColor) {
      if (!notifyPocketSelect || !notifySizeSelect || !notifyColorSelect) return;
      var pocketCount = parseInt(notifyPocketSelect.value, 10) || 0;
      var sizeKey = notifySizeSelect.value;
      var choices = getNotifyColorChoices(getLoadedNotifyProduct(pocketCount), sizeKey);
      var requestedColor = selectedColor || notifyColorSelect.value;
      var selectedChoice = choices.find(function (color) { return ciEquals(color.value, requestedColor); });
      replaceSelectOptions(
        notifyColorSelect,
        choices,
        sizeKey ? (choices.length ? 'Select a sold-out color' : 'No sold-out colors for this size') : 'Select a case size first',
        selectedChoice ? selectedChoice.value : ''
      );
      syncNotifyHiddenFields();
    }

    function refreshNotifySizeOptions(selectedSize, selectedColor) {
      if (!notifyPocketSelect || !notifySizeSelect || !notifyColorSelect) return;
      var pocketCount = parseInt(notifyPocketSelect.value, 10) || 0;
      var fetchToken = ++notifyProductFetchToken;
      var previousSize = notifySizeSelect.value;
      if (!pocketCount) {
        replaceSelectOptions(notifySizeSelect, [], 'Select a pocket count first', '');
        replaceSelectOptions(notifyColorSelect, [], 'Select a case size first', '');
        syncNotifyHiddenFields();
        return;
      }
      replaceSelectOptions(notifySizeSelect, [], 'Loading case sizes...', '');
      replaceSelectOptions(notifyColorSelect, [], 'Select a case size first', '');
      syncNotifyHiddenFields();
      fetchNotifyProduct(pocketCount).then(function (product) {
        if (fetchToken !== notifyProductFetchToken || parseInt(notifyPocketSelect.value, 10) !== pocketCount) return;
        if (!product) {
          replaceSelectOptions(notifySizeSelect, [], 'Could not load case sizes', '');
          replaceSelectOptions(notifyColorSelect, [], 'Select a case size first', '');
          setNotifyMessage('Could not load the sold-out colors. Please try again.', 'error');
          syncNotifyHiddenFields();
          return;
        }
        var choices = getNotifySizeChoices(product);
        var currentSize = previousSize && choices.some(function (size) { return ciEquals(size.key, previousSize); })
          ? previousSize
          : '';
        var requestedSize = selectedSize || currentSize;
        var selectedChoice = choices.find(function (size) { return ciEquals(size.key, requestedSize); });
        replaceSelectOptions(
          notifySizeSelect,
          choices.map(function (size) {
            return { value: size.key, label: size.display_name || size.key };
          }),
          choices.length ? 'Select a case size' : 'No case sizes with sold-out colors',
          selectedChoice ? selectedChoice.key : ''
        );
        refreshNotifyColorOptions(selectedColor || '');
      }).catch(function (err) {
        if (fetchToken !== notifyProductFetchToken) return;
        console.error('[magnano-v2] notify product fetch failed:', err);
        replaceSelectOptions(notifySizeSelect, [], 'Could not load case sizes', '');
        replaceSelectOptions(notifyColorSelect, [], 'Select a case size first', '');
        setNotifyMessage('Could not load the sold-out colors. Please try again.', 'error');
        syncNotifyHiddenFields();
      });
    }

    function populateNotifyForm(options) {
      if (!notifyFormEl || !notifyPocketSelect || !notifySizeSelect || !notifyColorSelect) return;
      setNotifyMessage('', 'neutral');
      options = options || {};
      var pocketChoices = getNotifyPocketChoices();
      var selectedPocketCount = parseInt(options.pocketCount || pickerState.pocketCount, 10) || 0;
      if (selectedPocketCount && !pocketChoices.some(function (choice) { return choice.value === String(selectedPocketCount); })) {
        pocketChoices.push({ value: String(selectedPocketCount), label: formatPocketCountLabel(selectedPocketCount) });
      }
      replaceSelectOptions(
        notifyPocketSelect,
        pocketChoices,
        pocketChoices.length ? 'Select a pocket count' : 'No pocket counts loaded',
        selectedPocketCount ? String(selectedPocketCount) : ''
      );
      var selectedSize = options.caseSize || (selectedPocketCount === pickerState.pocketCount ? pickerState.size : '') || '';
      refreshNotifySizeOptions(selectedSize, options.color || '');
      if (!pocketChoices.length) {
        setNotifyMessage('No pocket-count products are available for back-in-stock notifications.', 'neutral');
      }
    }

    function openNotifyModal(options) {
      if (!notifyModalEl) return;
      if (typeof options === 'string') options = { caseSize: options };
      populateNotifyForm(options || {});
      notifyModalEl.classList.remove('tw:hidden');
      notifyModalEl.setAttribute('data-open', 'true');
      window.setTimeout(function () {
        if (notifyEmailInput && !notifyEmailInput.value) notifyEmailInput.focus();
        else if (notifyPocketSelect) notifyPocketSelect.focus();
      }, 0);
    }

    function closeNotifyModal() {
      if (!notifyModalEl) return;
      notifyModalEl.classList.add('tw:hidden');
      notifyModalEl.removeAttribute('data-open');
      setNotifySubmitting(false);
    }

    function validateNotifyResponse(response) {
      if (!response || response.result !== 'success') {
        throw new Error(response && response.error ? response.error : 'Apps Script returned an error');
      }
      return response;
    }

    function submitNotifyData(data) {
      if (window.jQuery) {
        return new Promise(function (resolve, reject) {
          window.jQuery.ajax({
            url: NOTIFY_ENDPOINT,
            method: 'GET',
            dataType: 'json',
            data: data
          }).done(function (response) {
            try {
              resolve(validateNotifyResponse(response));
            } catch (err) {
              reject(err);
            }
          }).fail(reject);
        });
      }
      var params = new URLSearchParams(data);
      return fetch(NOTIFY_ENDPOINT + '?' + params.toString(), { method: 'GET' }).then(function (response) {
        if (!response.ok) throw new Error('Notify request failed: ' + response.status);
        return response.json();
      }).then(validateNotifyResponse);
    }

    function onNotifySubmit(e) {
      if (!notifyFormEl) return;
      e.preventDefault();
      syncNotifyHiddenFields();
      var data = {
        Product: notifyProductInput ? notifyProductInput.value.trim() : '',
        ProductVariantLabel: notifyVariantLabelInput ? notifyVariantLabelInput.value.trim() : '',
        PocketCount: notifyPocketCountInput ? notifyPocketCountInput.value.trim() : '',
        CaseSize: notifyCaseSizeInput ? notifyCaseSizeInput.value.trim() : '',
        ColorVariant_1: notifyFirstColorInput ? notifyFirstColorInput.value.trim() : '',
        Date: new Date().toISOString().split('T')[0],
        Email: notifyEmailInput ? notifyEmailInput.value.trim() : ''
      };
      if (notifyDateInput) notifyDateInput.value = data.Date;
      if (!data.Product || !data.PocketCount || !data.CaseSize || !data.ColorVariant_1 || !data.Email) {
        setNotifyMessage('Please select the pocket count, case size, and sold-out color, then enter your email address.', 'error');
        return;
      }
      setNotifySubmitting(true);
      setNotifyMessage('', 'neutral');
      submitNotifyData(data).then(function () {
        setNotifyMessage('Thank you. We will notify you when this design is back in stock.', 'success');
        if (notifyEmailInput) notifyEmailInput.value = '';
      }).catch(function (err) {
        console.error('[magnano-v2] notify submit failed:', err);
        setNotifyMessage('There was an error submitting your request. Please try again.', 'error');
      }).then(function () {
        setNotifySubmitting(false);
      }, function () {
        setNotifySubmitting(false);
      });
    }

    function closeCompareTooltip(callback) {
      if (!currentTooltip) {
        currentTooltipTrigger = null;
        if (callback) callback();
        return;
      }
      var tooltip = currentTooltip;
      function cleanup() {
        if (tooltip && tooltip.parentNode) tooltip.parentNode.removeChild(tooltip);
        if (currentTooltip === tooltip) currentTooltip = null;
        currentTooltipTrigger = null;
        if (callback) callback();
      }
      if (window.jQuery) {
        window.jQuery(tooltip).fadeOut(200, cleanup);
      } else {
        cleanup();
      }
    }

    function getCompareTooltipUrl(trigger) {
      if (!trigger) return '';
      var fallbackUrl = trigger.getAttribute('data-tooltip') || '';
      if (!trigger.hasAttribute('data-size-compare-tooltip')) return fallbackUrl;

      var pocketCount = parseInt(pickerState.pocketCount, 10) || 0;
      if (!pocketCount) return fallbackUrl;
      return trigger.getAttribute('data-tooltip-pocket-' + pocketCount) || fallbackUrl;
    }

    function showCompareTooltip(trigger) {
      var tooltipUrl = getCompareTooltipUrl(trigger);
      if (!tooltipUrl) return;

      var tooltip = document.createElement('div');
      tooltip.className = 'dynamic-tooltip';
      tooltip.style.backgroundImage = 'url("' + tooltipUrl.replace(/"/g, '\\"') + '")';
      tooltip.style.position = 'absolute';
      tooltip.style.display = 'none';
      document.body.appendChild(tooltip);
      currentTooltip = tooltip;
      currentTooltipTrigger = trigger;

      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
      var isMobile = viewportWidth <= 768;
      var imgWidth = isMobile ? viewportWidth * 0.85 : 750;
      var img = new Image();

      img.onload = function () {
        if (currentTooltip !== tooltip) return;
        var naturalWidth = img.naturalWidth || img.width || imgWidth;
        var naturalHeight = img.naturalHeight || img.height || imgWidth;
        if (!isMobile && naturalWidth < 750) imgWidth = naturalWidth;
        var imgHeight = (imgWidth / naturalWidth) * naturalHeight;
        var rect = trigger.getBoundingClientRect();
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

        tooltip.style.width = imgWidth + 'px';
        tooltip.style.height = imgHeight + 'px';
        tooltip.style.top = (rect.top + scrollTop + 20) + 'px';
        tooltip.style.left = Math.max((viewportWidth - imgWidth) / 2, 0) + 'px';

        if (window.jQuery) {
          window.jQuery(tooltip).fadeIn(200);
        } else {
          tooltip.style.display = 'block';
        }
      };
      img.onerror = function () {
        if (currentTooltip === tooltip) closeCompareTooltip();
      };
      img.src = tooltipUrl;
    }

    function toggleCompareTooltip(trigger) {
      if (currentTooltipTrigger === trigger) {
        closeCompareTooltip();
        return;
      }
      closeCompareTooltip(function () {
        showCompareTooltip(trigger);
      });
    }

    function readInlineJson(elementId) {
      var el = document.getElementById(elementId);
      if (!el || !el.textContent.trim()) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        console.warn('[magnano-v2] JSON parse failed for #' + elementId + ': ' + e.message);
        return null;
      }
    }

    function extractFirstNumber(value) {
      var match = String(value || '').match(/(\d+)/);
      return match ? parseInt(match[1], 10) : 0;
    }

    function ciIncludes(haystack, needle) {
      return String(haystack || '').toLowerCase().indexOf(String(needle).toLowerCase()) !== -1;
    }

    function ciEquals(a, b) {
      return String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();
    }

    function toLookupKey(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/['"]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function parseUrlPrefill() {
      var params;
      try {
        params = new URLSearchParams(window.location.search || '');
      } catch (err) {
        return null;
      }

      var hasPockets = params.has('pockets');
      var hasSize = params.has('size');
      var hasColor = params.has('color');
      if (!hasPockets && !hasSize && !hasColor) return null;

      var rawPockets = hasPockets ? String(params.get('pockets') || '').trim() : '';
      var rawSize = hasSize ? String(params.get('size') || '').trim() : '';
      var rawColor = hasColor ? String(params.get('color') || '').trim() : '';
      var pocketCount = /^[1-9]\d*$/.test(rawPockets) ? parseInt(rawPockets, 10) : null;

      return {
        hasPockets: hasPockets,
        hasSize: hasSize,
        hasColor: hasColor,
        rawPockets: rawPockets,
        rawSize: rawSize,
        rawColor: rawColor,
        pocketCount: pocketCount,
        pocketStatus: hasPockets ? 'pending' : 'not_requested',
        sizeStatus: hasSize ? 'pending' : 'not_requested',
        colorStatus: hasColor ? 'pending' : 'not_requested',
        resolvedSizeKey: null
      };
    }

    function setUrlPrefillStatus(part, status) {
      var prefill = pickerState.urlPrefill;
      if (!prefill) return;
      if (part === 'pockets') prefill.pocketStatus = status;
      if (part === 'size') prefill.sizeStatus = status;
      if (part === 'color') prefill.colorStatus = status;
      section.setAttribute('data-url-prefill', 'true');
      section.setAttribute('data-url-prefill-' + part + '-status', status);
    }

    function setPocketCountValidationMessage(message) {
      var el = section.querySelector('[data-pocket-count-validation]');
      if (!el) return;
      el.textContent = message || '';
      el.classList.toggle('tw:hidden', !message);
    }

    function setSizeValidationMessage(message) {
      var el = section.querySelector('[data-size-validation]');
      if (!el) return;
      el.textContent = message || '';
      el.classList.toggle('tw:hidden', !message);
    }

    function setPackValidationMessage(message) {
      var el = section.querySelector('[data-pack-validation]');
      if (!el) return;
      el.textContent = message || '';
      el.classList.toggle('tw:hidden', !message);
    }

    function requestedValueLabel(value) {
      var text = String(value || '').trim();
      return text ? '"' + text + '"' : 'from this link';
    }

    function resolvePocketPrefill(prefill) {
      if (!prefill || !prefill.hasPockets || !prefill.pocketCount) {
        return { status: 'unknown', entry: null };
      }
      var entry = findDispatchEntry(prefill.pocketCount);
      if (!entry) return { status: 'unknown', entry: null };
      if (entry.status !== 'active' || !entry.handle) return { status: 'unavailable', entry: entry };
      return { status: 'valid', entry: entry };
    }

    function resolveSizePrefill(rawSize, sizes) {
      var key = toLookupKey(rawSize);
      if (!key || !sizes || !sizes.length) return null;

      var direct = sizes.find(function (size) {
        return [size.key, size.label, size.display_name].some(function (value) {
          return value && toLookupKey(value) === key;
        });
      });
      if (direct) return direct;

      var alias = {
        'pill': 'pill',
        'vitamin': 'vitamin',
        'vitamin-xl': 'vitamin-xl'
      }[key];
      if (!alias) return null;

      return sizes.find(function (size) {
        var sizeKey = toLookupKey(size.key || size.label || size.display_name);
        if (alias === 'pill') return sizeKey.indexOf('pill') !== -1 && sizeKey.indexOf('vitamin') === -1;
        if (alias === 'vitamin') return sizeKey.indexOf('vitamin') !== -1 && sizeKey.indexOf('xl') === -1;
        return sizeKey.indexOf('vitamin') !== -1 && sizeKey.indexOf('xl') !== -1;
      }) || null;
    }

    function isUrlSizeBlockingDefault() {
      var prefill = pickerState.urlPrefill;
      if (!prefill || !prefill.hasSize) return false;
      return prefill.sizeStatus === 'pending' || prefill.sizeStatus === 'unknown' || prefill.sizeStatus === 'sold_out';
    }

    function isUrlUnavailableSizeKey(key) {
      var prefill = pickerState.urlPrefill;
      return !!(prefill && prefill.sizeStatus === 'sold_out' && prefill.resolvedSizeKey === key);
    }

    function cancelUrlPrefillFromStep(step) {
      var prefill = pickerState.urlPrefill;
      if (!prefill) return;
      urlPrefillRun += 1;
      if (step === '1') {
        if (prefill.hasPockets) setUrlPrefillStatus('pockets', 'manual');
        if (prefill.hasSize) setUrlPrefillStatus('size', 'manual');
        if (prefill.hasColor) setUrlPrefillStatus('color', 'manual');
        prefill.resolvedSizeKey = null;
        setPocketCountValidationMessage('');
        setSizeValidationMessage('');
        setPackValidationMessage('');
        setColorValidationMessage('');
      } else if (step === '2') {
        if (prefill.hasSize) setUrlPrefillStatus('size', 'manual');
        if (prefill.hasColor) setUrlPrefillStatus('color', 'manual');
        prefill.resolvedSizeKey = null;
        setSizeValidationMessage('');
        setPackValidationMessage('');
        setColorValidationMessage('');
      } else if (step === '3' || step === '4') {
        if (prefill.hasColor) setUrlPrefillStatus('color', 'manual');
        setPackValidationMessage('');
        setColorValidationMessage('');
      }
    }

    function isVariantSellable(v) {
      if (!v) return false;
      var hasInventoryManagement = Object.prototype.hasOwnProperty.call(v, 'inventory_management');
      return v.available === true
          || (hasInventoryManagement && !v.inventory_management)
          || v.inventory_policy === 'continue';
    }

    // Travel box is stock-gated: a continue-selling variant with nothing on hand
    // is still unavailable here, because we never preorder a travel box.
    function travelStockRemaining(variant) { return getSetMatcher().travelStockRemaining(variant); }

    function isTravelVariantInStock(variant) { return getSetMatcher().isTravelVariantInStock(variant); }

    // `product | json` drops the inventory fields, so the section emits them beside
    // the travel product blob. Merge them in before anything reads availability.
    function applyTravelInventory(inventoryById) {
      if (!travelProduct || !travelProduct.variants || !inventoryById) return;
      travelProduct.variants.forEach(function (v) {
        var info = inventoryById[String(v.id)];
        if (!info) return;
        v.inventory_quantity = info.inventory_quantity;
        v.inventory_management = info.inventory_management;
        v.inventory_policy = info.inventory_policy;
      });
    }

    function findTierVariant(packCount, pocketCount, size) {
      var resolver = window.theme && window.theme.magnanoTier;
      if (!resolver) return null;
      return resolver.findVariant(tierProduct, {
        caseCount: packCount,
        pocketCount: pocketCount,
        caseSize: size
      });
    }

    function findCaseVariant(size, color) {
      if (!caseProduct || !caseProduct.variants) return null;
      return caseProduct.variants.find(function (v) {
        return ciEquals(v.option1, size) && ciEquals(v.option2, color) && isVariantSellable(v);
      }) || null;
    }

    function getSetMatcher() {
      return window.theme.magnanoSet.createMatcher({ lid: lidProduct, pocket: pocketProduct, travel: travelProduct }, cartReservedByVariantId);
    }
    function getAddonSizeKey(size) { return getSetMatcher().getAddonSizeKey(size); }
    function findLidVariant(size, pockets, mode) { return getSetMatcher().findLidVariant(size, pockets, mode); }
    function findPocketVariant(size, pockets, mode) { return getSetMatcher().findPocketVariant(size, pockets, mode); }
    function findTravelVariant(size, pockets) { return getSetMatcher().findTravelVariant(size, pockets); }


    function buildBundleId() {
      return String(Date.now()) + String(Math.floor(Math.random() * 1000)).padStart(3, '0');
    }

    function buildPayload() {
      var count = pickerState.packCount || 0;
      var tier = findTierVariant(count, pickerState.pocketCount, pickerState.size);
      if (!tier || !isVariantSellable(tier) || !validateLidEngraving().ok) return null;
      var variants = getSelectedCaseVariants();
      if (variants.length !== count) return null;
      var used = {};
      variants.forEach(function (variant) { var id = String(variant.id); used[id] = (used[id] || 0) + 1; });
      if (variants.some(function (variant) { return used[String(variant.id)] > getEffectiveVariantCap(variant); })) return null;
      var lid = pickerState.lidEngraving || {}, pocket = pickerState.pocketEngraving || {};
      var includeLid = lid.mode !== 'NONE' && lidVariant && isVariantSellable(lidVariant);
      var includePocket = pocket.mode !== 'NONE' && pocketVariant && isVariantSellable(pocketVariant);
      var line = window.theme.magnanoSet.buildSetLine({
        id: buildBundleId(), tier: tier, cases: variants, pockets: pickerState.pocketCount,
        lid: { variant: includeLid ? lidVariant : null, labels: includeLid ? lid.labels : [] },
        pocket: { variant: includePocket ? pocketVariant : null, labels: includePocket ? (pocket.labels || []).map(function (label) { return formatPocketLabelForCart(pocket.mode, label); }) : [] },
        travel: pickerState.travelBox && pickerState.travelBox.selected && isTravelVariantInStock(travelVariant) ? travelVariant : null,
        preorder: computePreorderFlagsForSelectedCases(), eta: getPreorderEtaText()
      });
      return line ? { items: [line] } : null;
    }

    function setAtcLabel(text) {
      var labelEl = atcBtn && atcBtn.querySelector('[data-atc-label]');
      if (labelEl) labelEl.textContent = text;
    }
    function setAtcSpinner(visible) {
      var spinnerEl = atcBtn && atcBtn.querySelector('[data-atc-spinner]');
      if (spinnerEl) spinnerEl.classList.toggle('tw:hidden', !visible);
    }

    function setAtcError(message) {
      if (!atcErrorEl) return;
      var msgEl = atcErrorEl.querySelector('[data-atc-error-message]');
      if (message) {
        if (msgEl) msgEl.textContent = message;
        atcErrorEl.classList.remove('tw:hidden');
      } else {
        if (msgEl) msgEl.textContent = '';
        atcErrorEl.classList.add('tw:hidden');
      }
    }

    function onAtcClick() {
      if (!isAtcReady()) return;
      var payload = buildPayload();
      if (!payload) {
        setAtcError('We could not build your bundle. Please review your selections.');
        return;
      }
      setAtcError('');
      atcBtn.disabled = true;
      setAtcLabel('Adding…');
      setAtcSpinner(true);
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Could not check your cart. Please try again.');
          return response.json();
        })
        .then(function (cart) {
          var setModule = window.theme.magnanoSet;
          var count = setModule.countSets(cart.items || []);
          if (count >= setModule.MAX_SETS) throw new Error('Your cart already holds ' + count + ' MagNano sets. Please check out or remove a set before adding another.');
          return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload)
          });
        })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw new Error(err.description || err.message || 'Add to cart failed');
            });
          }
          return response.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          setAtcError(err.message || 'Add to cart failed. Please try again.');
          setAtcSpinner(false);
          refreshAtc();
        });
    }

    function getStepEl(step) {
      return section.querySelector('[data-step="' + step + '"]');
    }

    function setStepHidden(step, hidden) {
      var el = getStepEl(step);
      if (!el) return;
      el.classList.toggle('tw:hidden', !!hidden);
      el.setAttribute('data-hidden', hidden ? 'true' : 'false');
      if (hidden) {
        el.setAttribute('aria-hidden', 'true');
        setStepBodyVisible(step, false);
        setStepActive(step, false);
        if (pickerState.expandedStep === step) pickerState.expandedStep = '';
      } else {
        el.removeAttribute('aria-hidden');
      }
    }

    function setStepLocked(step, locked) {
      var el = getStepEl(step);
      if (!el) return;
      el.setAttribute('data-locked', locked ? 'true' : 'false');
      var header = el.querySelector('[data-step-header="' + step + '"]');
      if (header) {
        header.classList.toggle('tw:opacity-50', !!locked);
        header.classList.toggle('tw:cursor-not-allowed', !!locked);
      }
      applyStepVisualState(step);
    }

    function setStepTouched(step, touched) {
      var el = getStepEl(step);
      if (!el) return;
      pickerState.touchedSteps[step] = !!touched;
      el.setAttribute('data-touched', touched ? 'true' : 'false');
      applyStepVisualState(step);
      var summary = section.querySelector('[data-step-summary="' + step + '"]');
      if (summary) {
        var hasText = !!summary.getAttribute('data-summary-value');
        summary.classList.toggle('tw:hidden', !(hasText && touched));
      }
    }

    function setStepActive(step, active) {
      var el = getStepEl(step);
      if (!el) return;
      el.setAttribute('data-active', active ? 'true' : 'false');
      applyStepVisualState(step);
    }

    function getStepVisualState(el) {
      if (!el) return 'pending';
      var active = el.getAttribute('data-active') === 'true';
      var touched = el.getAttribute('data-touched') === 'true';
      var locked = el.getAttribute('data-locked') === 'true';
      if (active && !locked) return 'active';
      if (touched && !locked) return 'confirmed';
      return 'pending';
    }

    function applyStepVisualState(step) {
      var el = getStepEl(step);
      if (!el) return;
      var state = getStepVisualState(el);
      var active = state === 'active';
      var confirmed = state === 'confirmed';
      var pending = state === 'pending';

      el.classList.toggle('tw:border-blue-300', active);
      el.classList.toggle('tw:border-green-300', confirmed);
      el.classList.toggle('tw:border-gray-300', pending);
      el.classList.toggle('tw:ring-1', active || confirmed);
      el.classList.toggle('tw:ring-blue-300', active);
      el.classList.toggle('tw:ring-green-300', confirmed);
      el.classList.toggle('tw:shadow-sm', active || confirmed);

      var header = el.querySelector('[data-step-header="' + step + '"]');
      if (header) {
        header.classList.toggle('tw:bg-blue-50', active);
        header.classList.toggle('tw:bg-green-50', confirmed);
        header.classList.toggle('tw:bg-gray-50', pending);
        header.classList.toggle('tw:text-gray-800', active || confirmed);
        header.classList.toggle('tw:text-gray-700', pending);
      }

      var chevron = el.querySelector('[data-step-chevron]');
      if (chevron) {
        chevron.classList.toggle('tw:rotate-180', active);
        chevron.classList.toggle('tw:text-blue-700', active);
        chevron.classList.toggle('tw:text-green-700', confirmed);
        chevron.classList.toggle('tw:text-gray-500', pending);
      }

      var badge = el.querySelector('[data-step-badge]');
      if (badge) {
        badge.setAttribute('data-state', state);
        badge.classList.toggle('tw:text-gray-800', active || confirmed);
        badge.classList.toggle('tw:text-gray-700', pending);
        var chk = badge.querySelector('[data-badge-check]');
        if (chk) {
          chk.classList.toggle('tw:hidden', !confirmed);
          chk.classList.toggle('tw:inline-flex', confirmed);
        }
      }
    }

    function setStepSummary(step, text) {
      var el = section.querySelector('[data-step-summary="' + step + '"]');
      if (!el) return;
      var value = text || '';
      el.innerHTML = '';
      if (value) {
        var labelEl = document.createElement('span');
        labelEl.className = 'tw:font-normal tw:text-gray-600';
        labelEl.textContent = 'Selected: ';
        var valueEl = document.createElement('span');
        valueEl.className = 'tw:font-bold tw:text-black';
        valueEl.textContent = value;
        el.appendChild(labelEl);
        el.appendChild(valueEl);
        el.setAttribute('data-summary-value', value);
      } else {
        el.removeAttribute('data-summary-value');
      }
      var stepEl = getStepEl(step);
      var touched = stepEl && stepEl.getAttribute('data-touched') === 'true';
      el.classList.toggle('tw:hidden', !(value && touched));
    }

    function setStepBodyVisible(step, visible) {
      var body = section.querySelector('[data-step-body="' + step + '"]');
      if (!body) return;
      body.setAttribute('data-collapsed', visible ? 'false' : 'true');
      if (visible) {
        body.removeAttribute('inert');
      } else {
        body.setAttribute('inert', '');
        body.querySelectorAll('[popover]').forEach(function (p) {
          if (typeof p.matches === 'function' && p.matches(':popover-open') && typeof p.hidePopover === 'function') {
            p.hidePopover();
          }
        });
      }
    }

    function collapseAll() {
      section.querySelectorAll('[data-step]').forEach(function (el) {
        var n = el.getAttribute('data-step');
        setStepBodyVisible(n, false);
        setStepActive(n, false);
      });
    }

    function renderPocketSlots() {
      var slots = section.querySelectorAll('[data-pocket-slot]');
      for (var i = 0; i < slots.length; i++) {
        var slot = slots[i];
        var pc = parseInt(slot.getAttribute('data-pocket-slot'), 10);
        var isUnavailable = slot.disabled || slot.getAttribute('aria-disabled') === 'true';
        var isSelected = pc === pickerState.pocketCount && !isUnavailable;
        slot.classList.toggle('tw:border-black', isSelected);
        slot.classList.toggle('tw:border-2', isSelected);
        slot.classList.toggle('tw:bg-gray-50', isSelected);
        slot.classList.toggle('tw:border', !isSelected);
        slot.classList.toggle('tw:border-gray-300', !isSelected && !slot.disabled);
        var check = slot.querySelector('[data-pocket-check]');
        if (check) check.classList.toggle('tw:hidden', !isSelected);
      }
    }

    var moneyFormat = section.getAttribute('data-money-format') || '${{amount}}';

    function formatMoneySafe(cents) {
      var n = parseInt(cents, 10);
      if (!isFinite(n)) return '';
      if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
        return window.theme.Currency.formatMoney(n, (window.theme.moneyFormat || moneyFormat));
      }
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(n, moneyFormat);
      }
      return '$' + (n / 100).toFixed(2);
    }

    var formatPriceCents = formatMoneySafe;

    function getSizeData(key) {
      if (!caseProduct || !caseProduct.sizes) return null;
      return caseProduct.sizes.find(function (s) { return s.key === key; }) || null;
    }

    function setStep2State(state) {
      var loadingEl = section.querySelector('[data-step-loading="2"]');
      var errorEl = section.querySelector('[data-step-error="2"]');
      var rowsEl = section.querySelector('[data-size-rows]');
      var confirmBtn = section.querySelector('[data-step-confirm="2"]');
      if (loadingEl) loadingEl.classList.toggle('tw:hidden', state !== 'loading');
      if (errorEl) errorEl.classList.toggle('tw:hidden', state !== 'error');
      if (rowsEl) rowsEl.classList.toggle('tw:hidden', state !== 'ready');
      if (sizeCapacityBar) sizeCapacityBar.classList.toggle('tw:hidden', state !== 'ready');
      if (confirmBtn) confirmBtn.classList.toggle('tw:hidden', state !== 'ready');
    }

    function setStep2Error(message) {
      var msgEl = section.querySelector('[data-step-error-message="2"]');
      if (msgEl) msgEl.textContent = message;
      setStep2State('error');
    }

    function isSizeUnavailable(size) {
      if (!size) return true;
      return size.released === false || !!size.sold_out;
    }

    function isSizeColorCatalogEmpty(size) {
      if (!size || !caseProduct || !Array.isArray(caseProduct.variants)) return true;
      return !caseProduct.variants.some(function (variant) {
        return ciEquals(variant.option1, size.key);
      });
    }

    function getSizeUnavailableLabel(size) {
      if (!size) return 'Coming Soon';
      if (isSizeColorCatalogEmpty(size)) return 'No colors are available for this selection.';
      if (size.released === false) return 'Coming Soon';
      return (size.sold_out_label && String(size.sold_out_label).trim()) || 'Sold Out';
    }

    function prepareSizePresentation() {
      var sizes = caseProduct && caseProduct.sizes || [];
      var pc = parseInt(caseProduct && caseProduct.pocket_count, 10) || 0;
      var vitamin = sizes.find(function (size) { return /vitamin(?: |-)case$/i.test(size.key); });
      var models = sizes.map(function (size) {
        var counts = size.pill_counts;
        var launch = !sizeStep.validCounts(counts) && size.released === false
          && vitamin && sizeStep.validCounts(vitamin.pill_counts);
        return { key: size.key, name: size.display_name || size.key, thumbnail: size.thumbnail,
          shape: pc === 2 ? 'split' : 'v', counts: launch ? vitamin.pill_counts : counts, launch: !!launch };
      });
      if (!sizes.length || pc > 2) return { icons: false, rows: models.map(function (row) { return Object.assign({}, row, { svg: '', capacity: '' }); }) };
      return sizeStep.prepare(models);
    }

    function updateSizeCapacityBar(presentation) {
      if (sizeCapacityBar && sizeCapacityBar.parentNode) sizeCapacityBar.parentNode.removeChild(sizeCapacityBar);
      sizeCapacityBar = null;
      var rowsEl = section.querySelector('[data-size-rows]');
      if (rowsEl && presentation && presentation.icons) {
        sizeCapacityBar = sizeStep.createBar();
        rowsEl.parentNode.insertBefore(sizeCapacityBar, rowsEl);
      }
    }

    function renderSizeRows() {
      var rowsEl = section.querySelector('[data-size-rows]');
      if (!rowsEl) return;
      rowsEl.innerHTML = '';
      updateSizeCapacityBar(null);
      if (!sizeStep) {
        setStep2Error('Could not display case sizes. Please refresh the page.');
        return;
      }
      if (!caseProduct || !caseProduct.sizes || !caseProduct.sizes.length) {
        setStep2Error('No sizes available for ' + (pickerState.dispatchEntry && pickerState.dispatchEntry.handle) + '.');
        return;
      }

      var keepKey = pickerState.size && caseProduct.sizes.some(function (s) {
        return s.key === pickerState.size && (!isSizeUnavailable(s) || isUrlUnavailableSizeKey(s.key));
      })
        ? pickerState.size
        : null;
      if (!keepKey && !isUrlSizeBlockingDefault()) {
        var firstAvailable = caseProduct.sizes.find(function (s) { return !isSizeUnavailable(s); });
        keepKey = firstAvailable ? firstAvailable.key : null;
      }
      pickerState.size = keepKey;
      specSizePocketCount = pickerState.size ? pickerState.pocketCount : 0;
      if (pickerState.size) refreshTravelState();
      renderProductThumbnailGallery(caseProduct);
      var presentation = prepareSizePresentation();
      updateSizeCapacityBar(presentation);

      caseProduct.sizes.forEach(function (size) {
        var li = document.createElement('li');
        li.setAttribute('data-size-row', '');
        li.setAttribute('data-size-key', size.key);
        if (isSizeUnavailable(size)) li.setAttribute('aria-disabled', 'true');
        rowsEl.appendChild(li);
        renderSingleSizeRow(li, size, presentation);
      });

      setStep2State('ready');
      renderSpecAccordionSize(pickerState.size);
    }

    function renderSingleSizeRow(li, size, presentation) {
      li.innerHTML = '';
      var isSelected = size.key === pickerState.size;
      var isUnavailable = isSizeUnavailable(size);
      if (isUnavailable) li.setAttribute('aria-disabled', 'true');
      else li.removeAttribute('aria-disabled');
      li.className = [
        'tw:bg-white tw:transition-all tw:duration-fast tw:ease-standard',
        isSelected ? 'tw:border-2 tw:border-black tw:bg-gray-50' : 'tw:border tw:border-gray-300',
        'tw:cursor-pointer tw:hover:shadow-md tw:hover:border-gray-400'
      ].join(' ');
      var row = presentation.rows.find(function (item) { return item.key === size.key; });
      sizeStep.appendRow(li, row, {
        selected: isSelected, disabled: isUnavailable,
        badge: isUnavailable ? getSizeUnavailableLabel(size) : size.best_seller ? 'Best seller' : '',
        tone: isUnavailable ? 'status-dark' : 'best'
      });
      // MagNano can show both a status and its independent best-seller flag.
      if (isUnavailable && size.best_seller) {
        var name = li.querySelector('[data-size-name]');
        var heading = document.createElement('span');
        heading.className = 'tw:flex tw:min-w-0 tw:items-center tw:gap-2';
        name.parentNode.insertBefore(heading, name);
        heading.appendChild(name);
        var badge = document.createElement('span');
        badge.setAttribute('data-size-best-seller', '');
        sizeStep.setBadge(heading, badge, 'Best seller', 'best', 'secondary');
        heading.appendChild(badge);
      }
    }

    function refreshSizeRowsSelection() {
      if (!sizeStep) return;
      var presentation = prepareSizePresentation();
      updateSizeCapacityBar(presentation);
      var rows = section.querySelectorAll('[data-size-row]');
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var size = getSizeData(row.getAttribute('data-size-key'));
        if (size) renderSingleSizeRow(row, size, presentation);
      }
    }

    function getEffectiveVariantCap(v) {
      if (!v) return 0;
      if (!v.inventory_management || v.inventory_policy === 'continue') return Infinity;
      var raw = Math.max(0, parseInt(v.inventory_quantity, 10) || 0);
      var reserved = cartReservedByVariantId[String(v.id)] || 0;
      return Math.max(0, raw - reserved);
    }

    function getVariantRawInventory(v) {
      var raw = parseInt(v && v.inventory_quantity, 10);
      return isNaN(raw) ? 0 : raw;
    }

    function getVariantCartReserved(v) {
      if (!v || !v.id) return 0;
      return cartReservedByVariantId[String(v.id)] || 0;
    }

    function isPreorderEligibleVariant(v) {
      return !!(v && v.inventory_management === 'shopify' && v.inventory_policy === 'continue' && isVariantSellable(v));
    }

    function isVariantPreorderForCount(v, selectedCount) {
      var count = parseInt(selectedCount, 10) || 0;
      if (count < 1 || !isPreorderEligibleVariant(v)) return false;
      return (getVariantRawInventory(v) - getVariantCartReserved(v)) < count;
    }

    function getPreorderEtaText() {
      return String(PREORDER_ETA_TEXT || '').trim() || 'Preorder';
    }

    function getPreorderBadgeLabel() {
      return (stockPillEl && stockPillEl.getAttribute('data-pre')) || 'Preorder';
    }

    function getVariantUsageForCandidate(entry, slotIdx) {
      if (!entry || !entry.variant) return 0;
      var id = String(entry.variant.id);
      var alloc = pickerState.colorAllocation || [];
      var count = 1;
      for (var i = 0; i < alloc.length; i++) {
        if (i === slotIdx) continue;
        var selected = alloc[i];
        if (!selected) continue;
        if (String(selected.variantId || '') === id || selected.colorName === entry.colorName) count += 1;
      }
      return count;
    }

    function isColorPreorderForSlot(entry, slotIdx) {
      return isVariantPreorderForCount(entry && entry.variant, getVariantUsageForCandidate(entry, slotIdx));
    }

    function getSelectedCaseVariants() {
      var packCount = pickerState.packCount || 0;
      var alloc = pickerState.colorAllocation || [];
      if (!pickerState.size || packCount < 1 || alloc.length !== packCount) return [];
      var variants = [];
      for (var i = 0; i < packCount; i++) {
        var entry = alloc[i];
        if (!entry || !entry.colorName) return [];
        var variant = findCaseVariant(pickerState.size, entry.colorName);
        if (!variant) return [];
        variants.push(variant);
      }
      return variants;
    }

    function computePreorderFlagsForSelectedCases() { return window.theme.magnanoSet.preorderFlags(getSelectedCaseVariants(), cartReservedByVariantId); }

    function computePreorderState(requireConfirmedColors) {
      if (requireConfirmedColors && !(pickerState.touchedSteps && pickerState.touchedSteps['4'])) {
        return { hasPreorder: false, eta: '' };
      }
      var flags = computePreorderFlagsForSelectedCases();
      var hasPreorder = flags.some(function (flag) { return !!flag; });
      return { hasPreorder: hasPreorder, eta: hasPreorder ? getPreorderEtaText() : '' };
    }

    function computePackCountCap() {
      if (!caseProduct || !caseProduct.variants || !pickerState.size) return MAX_PACK_COUNT;
      var total = 0;
      for (var i = 0; i < caseProduct.variants.length; i++) {
        var v = caseProduct.variants[i];
        if (v.option1 !== pickerState.size) continue;
        var cap = getEffectiveVariantCap(v);
        if (!isFinite(cap)) return MAX_PACK_COUNT;
        total += cap;
      }
      return Math.max(0, Math.min(MAX_PACK_COUNT, total));
    }

    function getTierPriceFor(packCount) {
      var v = findTierVariant(packCount, pickerState.pocketCount, pickerState.size);
      return v ? v.price : null;
    }

    function isPackCountAvailable(n) {
      if (!n || n < 1 || n > computePackCountCap()) return false;
      var v = findTierVariant(n, pickerState.pocketCount, pickerState.size);
      return !!(v && isVariantSellable(v));
    }

    function computeDefaultPackCount() {
      var cap = computePackCountCap();
      for (var n = cap; n >= 1; n--) {
        if (isPackCountAvailable(n)) return n;
      }
      return 0;
    }

    function renderPackCountSlots() {
      var cap = computePackCountCap();
      if (!isPackCountAvailable(pickerState.packCount)) {
        pickerState.packCount = computeDefaultPackCount();
      }

      var emptyEl = section.querySelector('[data-pack-empty]');
      if (emptyEl) emptyEl.classList.toggle('tw:hidden', pickerState.packCount > 0);
      var confirmBtn = section.querySelector('[data-step-confirm="3"]');
      if (confirmBtn) confirmBtn.disabled = pickerState.packCount < 1;

      var trigger = section.querySelector('[data-pack-trigger]');
      if (trigger) {
        trigger.disabled = pickerState.packCount < 1;
        var labelEl = trigger.querySelector('[data-pack-trigger-label]');
        if (labelEl) {
          labelEl.textContent = pickerState.packCount > 0
            ? (pickerState.packCount + (pickerState.packCount === 1 ? ' case' : ' cases'))
            : 'Unavailable';
        }
        var triggerBadge = trigger.querySelector('[data-pack-trigger-badge]');
        if (triggerBadge) triggerBadge.classList.toggle('tw:hidden', pickerState.packCount !== 7);
      }

      var options = section.querySelectorAll('[data-pack-option]');
      for (var i = 0; i < options.length; i++) {
        var opt = options[i];
        var n = parseInt(opt.getAttribute('data-pack-option'), 10);
        var tier = findTierVariant(n, pickerState.pocketCount, pickerState.size);
        var isUnavailable = n > cap || !tier || !isVariantSellable(tier);
        var isSelected = !isUnavailable && n === pickerState.packCount;
        opt.setAttribute('aria-disabled', isUnavailable ? 'true' : 'false');
        opt.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        opt.classList.toggle('tw:bg-gray-50', isSelected);
        var check = opt.querySelector('[data-pack-option-check]');
        if (check) check.classList.toggle('tw:hidden', !isSelected);
      }
    }

    var openPopup = null;
    var popupListenersBound = false;

    function getPopupForTrigger(trigger) {
      if (!trigger) return null;
      var popupId = trigger.getAttribute('popovertarget');
      if (!popupId) return null;
      var popup = document.getElementById(popupId);
      if (!popup || !section.contains(popup)) return null;
      return popup;
    }

    function placePopupUnder(popup) {
      if (!popup || !popup.id) return;
      var trigger = document.querySelector('[popovertarget="' + popup.id + '"]');
      if (!trigger) return;
      var rect = trigger.getBoundingClientRect();
      popup.style.position = 'fixed';
      popup.style.margin = '0';
      popup.style.left = rect.left + 'px';
      popup.style.right = 'auto';
      popup.style.bottom = 'auto';
      popup.style.width = rect.width + 'px';
      var popupHeight = popup.offsetHeight || 0;
      var spaceBelow = window.innerHeight - rect.bottom;
      if (spaceBelow < popupHeight + 16 && rect.top > popupHeight + 16) {
        popup.style.top = (rect.top - popupHeight - 4) + 'px';
      } else {
        popup.style.top = (rect.bottom + 4) + 'px';
      }
    }

    function preparePopupFromTrigger(trigger) {
      var popup = getPopupForTrigger(trigger);
      if (popup) placePopupUnder(popup);
    }

    function placeOpenPopup() {
      if (openPopup) placePopupUnder(openPopup);
    }

    function onPopupBeforeToggle(e) {
      if (e.newState === 'open') {
        placePopupUnder(e.target);
      }
    }

    function onPopupToggle(e) {
      var popup = e.target;
      if (e.newState === 'open') {
        openPopup = popup;
        placePopupUnder(popup);
        if (!popupListenersBound) {
          window.addEventListener('resize', placeOpenPopup);
          window.addEventListener('scroll', placeOpenPopup, true);
          popupListenersBound = true;
        }
      } else if (openPopup === popup) {
        openPopup = null;
        if (popupListenersBound) {
          window.removeEventListener('resize', placeOpenPopup);
          window.removeEventListener('scroll', placeOpenPopup, true);
          popupListenersBound = false;
        }
      }
    }

    function resetStepsAfter(step) {
      var startN = parseInt(step, 10) + 1;
      if (startN <= 5 && pickerState.lidEngraving) {
        pickerState.lidEngraving.mode = null;
        pickerState.lidEngraving.labels = [];
        lidVariant = null;
      }
      if (startN <= 6 && pickerState.pocketEngraving) {
        pickerState.pocketEngraving.mode = null;
        pickerState.pocketEngraving.labels = [];
        pickerState.pocketEngraving.dotwSync = true;
        pocketVariant = null;
      }
      var allSteps = section.querySelectorAll('[data-step]');
      for (var i = 0; i < allSteps.length; i++) {
        var n = parseInt(allSteps[i].getAttribute('data-step'), 10);
        if (n >= startN) {
          var k = String(n);
          setStepTouched(k, false);
          setStepSummary(k, '');
          setStepBodyVisible(k, false);
          setStepLocked(k, true);
        }
      }
      if (startN <= 7) syncTravelAvailabilityState();
    }

    function buildColorCatalogForSize(size) {
      if (!caseProduct || !caseProduct.variants || !size) return [];
      var seen = {};
      var catalog = [];
      caseProduct.variants.forEach(function (v) {
        if (v.option1 !== size) return;
        var colorName = String(v.option2 || '').trim();
        if (!colorName || seen[colorName]) return;
        seen[colorName] = true;
        var swatch = (v.case_color && v.case_color.swatch_image) ? v.case_color.swatch_image : null;
        catalog.push({
          colorName: colorName,
          variant: v,
          swatchImage: swatch,
          sortIndex: v.case_color ? v.case_color.sort_index : null,
          cap: getEffectiveVariantCap(v)
        });
      });
      return catalog.map(function (entry, sourceIndex) {
        return {
          entry: entry,
          sourceIndex: sourceIndex,
          sortIndex: getColorSortIndex(entry)
        };
      }).sort(function (a, b) {
        if (a.sortIndex !== null && b.sortIndex !== null && a.sortIndex !== b.sortIndex) {
          return a.sortIndex - b.sortIndex;
        }
        if (a.sortIndex !== null && b.sortIndex === null) return -1;
        if (a.sortIndex === null && b.sortIndex !== null) return 1;
        return a.sourceIndex - b.sourceIndex;
      }).map(function (item) {
        return item.entry;
      });
    }

    function getColorSortIndex(entry) {
      if (!entry || entry.sortIndex === null || entry.sortIndex === undefined) return null;
      var raw = String(entry.sortIndex).trim();
      if (!raw) return null;
      var parsed = Number(raw);
      return isFinite(parsed) ? parsed : null;
    }

    function getColorUsage(colorName, excludeSlotIdx) {
      var alloc = pickerState.colorAllocation || [];
      var n = 0;
      for (var i = 0; i < alloc.length; i++) {
        if (i === excludeSlotIdx) continue;
        if (alloc[i] && alloc[i].colorName === colorName) n += 1;
      }
      return n;
    }

    function getColorRemainingForSlot(entry, slotIdx) {
      if (!entry) return 0;
      var usageElsewhere = getColorUsage(entry.colorName, slotIdx);
      return isFinite(entry.cap) ? entry.cap - usageElsewhere : Infinity;
    }

    function isColorUnavailableForSlot(entry, slotIdx) {
      if (!entry) return true;
      return getColorRemainingForSlot(entry, slotIdx) <= 0;
    }

    function getSortedColorCatalogForSlot(catalog, slotIdx) {
      return catalog.map(function (entry, index) {
        return {
          entry: entry,
          index: index,
          sortIndex: getColorSortIndex(entry),
          unavailable: isColorUnavailableForSlot(entry, slotIdx)
        };
      }).sort(function (a, b) {
        if (a.unavailable !== b.unavailable) return a.unavailable ? 1 : -1;
        if (a.sortIndex !== null && b.sortIndex !== null && a.sortIndex !== b.sortIndex) {
          return a.sortIndex - b.sortIndex;
        }
        if (a.sortIndex !== null && b.sortIndex === null) return -1;
        if (a.sortIndex === null && b.sortIndex !== null) return 1;
        return a.index - b.index;
      }).map(function (item) {
        return item.entry;
      });
    }

    function defaultColorAllocation() {
      var packCount = pickerState.packCount || 0;
      if (!packCount) return [];
      var catalog = buildColorCatalogForSize(pickerState.size);
      var allocation = [];
      var used = {};
      for (var i = 0; i < packCount; i++) {
        var picked = null;
        for (var j = 0; j < catalog.length; j++) {
          var c = catalog[j];
          var u = used[c.colorName] || 0;
          var remaining = isFinite(c.cap) ? Math.max(0, c.cap - u) : Infinity;
          if (remaining > 0) { picked = c; break; }
        }
        if (!picked) break;
        allocation.push({ slot: i + 1, variantId: String(picked.variant.id), colorName: picked.colorName });
        used[picked.colorName] = (used[picked.colorName] || 0) + 1;
      }
      return allocation;
    }

    function syncPreviewDefaultsForPackCount(forceAllocation) {
      var packCount = pickerState.packCount || 0;
      if (packCount > 0 && pickerState.size && caseProduct) {
        if (forceAllocation || !pickerState.colorAllocation || pickerState.colorAllocation.length !== packCount) {
          pickerState.colorAllocation = defaultColorAllocation();
        }
      }

      if (!pickerState.travelBox) return;
      syncTravelAvailabilityState();
      syncTravelDefaultSelection();
      applyTravelVisual();
    }

    function getSwatchImageSrc(entry) {
      if (!entry) return '';
      return entry.swatchImage
        || (entry.variant && entry.variant.case_color && entry.variant.case_color.swatch_image)
        || '';
    }
    function getCasePhotoSrc(entry) {
      if (!entry || !entry.variant) return '';
      return getCasePreviewImageSrc(entry.variant);
    }

    function buildHorizontalColorPhoto(src, dataAttrName) {
      var frame = document.createElement('span');
      var frameWidth = 55;
      if (ciIncludes(pickerState.size, 'vitamin')) frameWidth = 65;
      else if (pickerState.pocketCount === 2) frameWidth = 72;
      frame.className = 'tw:flex tw:h-[32px] tw:flex-shrink-0 tw:items-center tw:justify-center tw:overflow-visible';
      frame.style.width = frameWidth + 'px';
      if (dataAttrName === 'data-color-trigger-image') frame.setAttribute('data-color-trigger-photo', '');
      if (src) {
        var img = document.createElement('img');
        img.alt = '';
        img.className = 'tw:w-[32px] tw:h-auto tw:rounded tw:object-cover tw:-rotate-90 tw:origin-center';
        if (dataAttrName) img.setAttribute(dataAttrName, '');
        img.src = src;
        frame.appendChild(img);
      } else {
        var placeholder = document.createElement('span');
        placeholder.className = 'magnano-v2-color-case-placeholder';
        placeholder.setAttribute('aria-hidden', 'true');
        frame.appendChild(placeholder);
      }
      return frame;
    }

    function updateColorTriggerPhoto(row, entry) {
      if (!row) return;
      var current = row.querySelector('[data-color-trigger-photo]');
      if (!current) return;
      current.replaceWith(buildHorizontalColorPhoto(getCasePhotoSrc(entry), 'data-color-trigger-image'));
    }

    function getColorBadges(entry) {
      var badges = entry && entry.variant && entry.variant.case_color && entry.variant.case_color.badges;
      return Array.isArray(badges) ? badges : [];
    }

    function buildColorBadgeWrap(entry, dataAttrName, includePreorderBadge) {
      var badges = getColorBadges(entry);
      var badgeWrap = null;
      function ensureBadgeWrap() {
        if (!badgeWrap) {
          badgeWrap = document.createElement('span');
          badgeWrap.className = 'tw:flex tw:items-center tw:gap-1 tw:flex-shrink-0';
          if (dataAttrName) badgeWrap.setAttribute(dataAttrName, '');
        }
        return badgeWrap;
      }
      badges.forEach(function (b) {
        if (!b || !b.name) return;
        ensureBadgeWrap();
        var badge = document.createElement('span');
        badge.className = 'tw:rounded-full tw:text-[10px] tw:font-medium tw:px-1.5 tw:py-0.5 tw:leading-tight tw:bg-gray-100 tw:text-gray-800';
        badge.textContent = b.name;
        if (b.color) {
          badge.style.background = b.color;
          badge.style.color = '#fff';
        }
        badgeWrap.appendChild(badge);
      });
      if (includePreorderBadge) {
        var preorderBadge = document.createElement('span');
        preorderBadge.setAttribute('data-color-preorder-badge', '');
        preorderBadge.className = 'tw:rounded-full tw:text-[10px] tw:font-semibold tw:px-1.5 tw:py-0.5 tw:leading-tight tw:bg-amber-100 tw:text-amber-800';
        preorderBadge.textContent = getPreorderBadgeLabel();
        ensureBadgeWrap().appendChild(preorderBadge);
      }
      return badgeWrap;
    }

    function updateColorTriggerBadges(row, entry) {
      if (!row) return;
      var trigger = row.querySelector('[data-color-trigger]');
      if (!trigger) return;
      var existing = trigger.querySelector('[data-color-trigger-badges]');
      if (existing) existing.remove();
      var slotIdx = parseInt(row.getAttribute('data-slot-index'), 10);
      var badgeWrap = buildColorBadgeWrap(entry, 'data-color-trigger-badges', !isNaN(slotIdx) && isColorPreorderForSlot(entry, slotIdx));
      if (!badgeWrap) return;
      var chevron = trigger.querySelector('[data-color-trigger-chevron]');
      trigger.insertBefore(badgeWrap, chevron || null);
    }

    function renderColorRows() {
      var rowsEl = section.querySelector('[data-color-rows]');
      if (!rowsEl) return;
      rowsEl.innerHTML = '';
      var packCount = pickerState.packCount || 0;
      if (!packCount) {
        renderColorSummary();
        return;
      }
      var catalog = buildColorCatalogForSize(pickerState.size);
      if (!catalog.length) {
        renderColorSummary();
        return;
      }
      if (!pickerState.colorAllocation || pickerState.colorAllocation.length !== packCount) {
        pickerState.colorAllocation = defaultColorAllocation();
      }
      for (var i = 0; i < packCount; i++) {
        rowsEl.appendChild(buildColorRow(i, catalog));
      }
      refreshColorOptions();
      renderColorSummary();
    }

    function buildColorRow(slotIdx, catalog) {
      var alloc = pickerState.colorAllocation[slotIdx];
      var entry = catalog.find(function (c) { return alloc && c.colorName === alloc.colorName; }) || catalog[0];
      var li = document.createElement('li');
      li.setAttribute('data-color-row', '');
      li.setAttribute('data-slot-index', String(slotIdx));
      li.className = 'tw:grid tw:grid-cols-[38px_1fr] tw:items-center tw:gap-2.5';

      var caseFrame = document.createElement('div');
      caseFrame.className = 'tw:relative tw:w-[38px] tw:h-[38px] tw:rounded-md tw:overflow-hidden tw:border tw:border-gray-300 tw:bg-gray-50 tw:flex tw:items-center tw:justify-center';
      caseFrame.setAttribute('data-color-row-preview', '');
      var caseImg = document.createElement('img');
      caseImg.setAttribute('data-color-row-image', '');
      caseImg.alt = (entry && entry.colorName) || ('Slot ' + (slotIdx + 1));
      caseImg.className = 'tw:w-full tw:h-full tw:object-cover';
      var swatchSrc = getSwatchImageSrc(entry);
      if (swatchSrc) caseImg.src = swatchSrc;
      caseFrame.appendChild(caseImg);
      var slotNumber = document.createElement('span');
      slotNumber.className = 'tw:absolute tw:bottom-0.5 tw:right-0.5 tw:flex tw:items-center tw:justify-center tw:w-4 tw:h-4 tw:rounded-full tw:bg-black/70 tw:text-white tw:text-[9px] tw:font-bold tw:leading-none';
      slotNumber.textContent = String(slotIdx + 1);
      caseFrame.appendChild(slotNumber);
      li.appendChild(caseFrame);

      var popupId = 'magnano-v2-color-popup-' + SECTION_ID + '-' + slotIdx;
      var photoSrc = getCasePhotoSrc(entry);
      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.setAttribute('data-color-trigger', '');
      trigger.setAttribute('data-slot-index', String(slotIdx));
      trigger.setAttribute('popovertarget', popupId);
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.className = [
        'tw:flex', 'tw:items-center', 'tw:justify-between', 'tw:gap-2',
        'tw:w-full', 'tw:pr-4', 'tw:py-1', 'tw:min-h-10', 'tw:max-h-12',
        'tw:bg-white', 'tw:border', 'tw:border-gray-200', 'tw:rounded-md',
        'tw:cursor-pointer', 'tw:text-left',
        'tw:transition-all', 'tw:duration-fast', 'tw:ease-standard',
        'tw:hover:border-gray-400',
        'tw:focus-visible:ring-2', 'tw:focus-visible:ring-black', 'tw:focus-visible:ring-offset-1', 'tw:focus:outline-none'
      ].join(' ');
      var triggerInner = document.createElement('span');
      triggerInner.className = 'tw:flex tw:items-center tw:gap-2 tw:min-w-0';
      triggerInner.appendChild(buildHorizontalColorPhoto(photoSrc, 'data-color-trigger-image'));
      var triggerName = document.createElement('span');
      triggerName.setAttribute('data-color-trigger-name', '');
      triggerName.className = 'tw:text-sm tw:text-gray-900 tw:truncate';
      triggerName.textContent = (entry && entry.colorName) || '';
      triggerInner.appendChild(triggerName);
      trigger.appendChild(triggerInner);
      var chevron = document.createElement('span');
      chevron.setAttribute('aria-hidden', 'true');
      chevron.setAttribute('data-color-trigger-chevron', '');
      chevron.className = 'tw:flex tw:items-center tw:justify-center tw:text-gray-500 tw:flex-shrink-0';
      chevron.innerHTML = '<svg class="tw:w-3 tw:h-2" viewBox="0 0 12 7" fill="none"><path d="M11 1L6 6L1 1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      trigger.appendChild(chevron);
      li.appendChild(trigger);
      updateColorTriggerBadges(li, entry);

      var popup = document.createElement('div');
      popup.id = popupId;
      popup.setAttribute('popover', 'auto');
      popup.setAttribute('data-color-popup', '');
      popup.setAttribute('data-slot-index', String(slotIdx));
      popup.setAttribute('role', 'listbox');
      popup.setAttribute('aria-label', 'Color for slot ' + (slotIdx + 1));
      popup.className = 'tw:m-0 tw:p-0 tw:border-0 tw:bg-transparent';
      var ul = document.createElement('ul');
      ul.setAttribute('data-color-options', '');
      ul.className = 'tw:list-none tw:m-0 tw:p-0 tw:bg-white tw:rounded-lg tw:border tw:border-gray-200 tw:shadow-lg tw:overflow-hidden tw:max-h-72 tw:overflow-y-auto';
      getSortedColorCatalogForSlot(catalog, slotIdx).forEach(function (c) {
        ul.appendChild(buildColorOption(c, slotIdx));
      });
      popup.appendChild(ul);
      popup.addEventListener('beforetoggle', onPopupBeforeToggle);
      popup.addEventListener('toggle', onPopupToggle);
      li.appendChild(popup);

      return li;
    }

    function buildColorOption(entry, slotIdx) {
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.setAttribute('data-color-option', entry.colorName);
      li.setAttribute('data-slot-index', String(slotIdx));
      li.className = [
        'tw:flex', 'tw:items-center', 'tw:gap-2',
        'tw:min-h-10', 'tw:max-h-12',
        'tw:px-3', 'tw:py-1.5',
        'tw:cursor-pointer',
        'tw:transition-colors', 'tw:duration-fast', 'tw:ease-standard',
        'tw:hover:bg-gray-50',
        'tw:aria-disabled:opacity-40', 'tw:aria-disabled:cursor-not-allowed', 'tw:aria-disabled:hover:bg-transparent'
      ].join(' ');

      var src = getCasePhotoSrc(entry);
      li.appendChild(buildHorizontalColorPhoto(src));

      var name = document.createElement('span');
      name.className = 'tw:flex-grow tw:text-sm tw:text-gray-900 tw:truncate';
      name.textContent = entry.colorName;
      li.appendChild(name);

      var badgeWrap = buildColorBadgeWrap(entry, 'data-color-option-badges', isColorPreorderForSlot(entry, slotIdx));
      if (badgeWrap) {
        li.appendChild(badgeWrap);
      }

      var check = document.createElement('span');
      check.setAttribute('data-color-option-check', '');
      check.className = 'tw:hidden tw:flex tw:items-center tw:justify-center tw:w-4 tw:h-4 tw:text-black tw:flex-shrink-0';
      check.innerHTML = '<svg class="tw:w-4 tw:h-4" viewBox="0 0 16 16" fill="currentColor"><path d="M6.5 11.4 2.6 7.5 4 6.1l2.5 2.5L12 3.1l1.4 1.4z"/></svg>';
      li.appendChild(check);

      return li;
    }

    function refreshColorOptions() {
      var rows = section.querySelectorAll('[data-color-row]');
      var catalog = buildColorCatalogForSize(pickerState.size);
      var byName = {};
      catalog.forEach(function (c) { byName[c.colorName] = c; });
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var slotIdx = parseInt(row.getAttribute('data-slot-index'), 10);
        var slotPick = pickerState.colorAllocation[slotIdx] && pickerState.colorAllocation[slotIdx].colorName;
        var list = row.querySelector('[data-color-options]');
        var options = row.querySelectorAll('[data-color-option]');
        var optionsByName = Object.create(null);
        if (slotPick && byName[slotPick]) updateColorTriggerBadges(row, byName[slotPick]);
        for (var j = 0; j < options.length; j++) {
          optionsByName[options[j].getAttribute('data-color-option')] = options[j];
        }
        if (list) {
          getSortedColorCatalogForSlot(catalog, slotIdx).forEach(function (entry) {
            var sortedOption = optionsByName[entry.colorName];
            if (sortedOption) list.appendChild(sortedOption);
          });
        }
        options = row.querySelectorAll('[data-color-option]');
        for (j = 0; j < options.length; j++) {
          var opt = options[j];
          var colorName = opt.getAttribute('data-color-option');
          var entry = byName[colorName];
          if (!entry) continue;
          var soldOutForThisSlot = isColorUnavailableForSlot(entry, slotIdx);
          opt.setAttribute('aria-disabled', soldOutForThisSlot ? 'true' : 'false');
          var isSelected = colorName === slotPick;
          opt.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          opt.classList.toggle('tw:bg-gray-50', isSelected);
          var check = opt.querySelector('[data-color-option-check]');
          var badgeWrap = opt.querySelector('[data-color-option-badges]');
          if (badgeWrap) badgeWrap.remove();
          badgeWrap = buildColorBadgeWrap(entry, 'data-color-option-badges', isColorPreorderForSlot(entry, slotIdx));
          if (badgeWrap) opt.insertBefore(badgeWrap, check || null);
          if (check) check.classList.toggle('tw:hidden', !isSelected);
        }
      }
    }

    function renderColorSummary() {
      var el = section.querySelector('[data-step-summary="4"]');
      if (!el) return;
      var alloc = pickerState.colorAllocation || [];
      el.innerHTML = '';
      if (!alloc.length || !pickerState.size) {
        el.classList.add('tw:hidden');
        el.removeAttribute('data-summary-value');
        return;
      }
      var catalog = buildColorCatalogForSize(pickerState.size);
      var byName = {};
      catalog.forEach(function (c) { byName[c.colorName] = c; });
      var container = document.createElement('span');
      container.className = 'tw:flex tw:flex-wrap tw:items-center';
      alloc.forEach(function (a, i) {
        var entry = a && byName[a.colorName];
        var slot = document.createElement('span');
        slot.className = 'tw:flex-shrink-0 tw:w-6 tw:overflow-visible';
        slot.setAttribute('role', 'img');
        slot.setAttribute('aria-label', (a && a.colorName) || ('Slot ' + (i + 1)));
        var src = getCasePhotoSrc(entry);
        if (src) {
          var img = document.createElement('img');
          img.src = src;
          img.alt = '';
          img.className = 'tw:block tw:w-full tw:h-auto tw:object-contain';
          slot.appendChild(img);
        }
        container.appendChild(slot);
      });
      el.appendChild(container);
      el.classList.remove('tw:hidden');
      el.setAttribute('data-summary-value', alloc.length + (alloc.length === 1 ? ' case' : ' cases'));
    }

    function setColorValidationMessage(message) {
      var el = section.querySelector('[data-color-validation]');
      if (!el) return;
      if (message) {
        el.textContent = message;
        el.classList.remove('tw:hidden');
      } else {
        el.textContent = '';
        el.classList.add('tw:hidden');
      }
    }

    function validateColorAllocation(allocation, requestedPackCount) {
      var alloc = Array.isArray(allocation) ? allocation : (pickerState.colorAllocation || []);
      var packCount = requestedPackCount || pickerState.packCount || 0;
      if (alloc.length !== packCount) return { ok: false, message: 'Color allocation length mismatch.' };
      var usage = {};
      for (var i = 0; i < alloc.length; i++) {
        if (!alloc[i] || !alloc[i].colorName) {
          return { ok: false, message: 'Slot ' + (i + 1) + ' has no color selected.' };
        }
        usage[alloc[i].colorName] = (usage[alloc[i].colorName] || 0) + 1;
      }
      var catalog = buildColorCatalogForSize(pickerState.size);
      var byName = {};
      catalog.forEach(function (c) { byName[c.colorName] = c; });
      for (var color in usage) {
        var entry = byName[color];
        if (!entry) return { ok: false, message: 'Color "' + color + '" no longer available for this size.' };
        if (isFinite(entry.cap) && usage[color] > entry.cap) {
          return { ok: false, message: 'Too many slots for ' + color + ' — using ' + usage[color] + ' but only ' + entry.cap + ' available.' };
        }
      }
      return { ok: true };
    }

    function resolveUrlColorPrefill(rawColor) {
      rawColor = String(rawColor || '').trim();
      if (!rawColor) {
        return {
          status: 'unknown',
          allocation: null,
          message: 'This prefill link must provide a case color. Please choose an available color.'
        };
      }

      var catalog = buildColorCatalogForSize(pickerState.size);
      var entry = catalog.find(function (candidate) {
        return toLookupKey(candidate.colorName) === toLookupKey(rawColor);
      });
      if (!entry) {
        return {
          status: 'unknown',
          allocation: null,
          message: 'Requested color ' + requestedValueLabel(rawColor) + ' is not available in this size. Please choose an available color.'
        };
      }

      var allocation = [];
      for (var i = 0; i < MAX_PACK_COUNT; i++) {
        allocation.push({
          slot: i + 1,
          variantId: String(entry.variant.id),
          colorName: entry.colorName
        });
      }

      var validation = validateColorAllocation(allocation, MAX_PACK_COUNT);
      if (!validation.ok) {
        return {
          status: 'sold_out',
          allocation: allocation,
          message: 'Seven cases in the requested color are not currently available. ' + validation.message
        };
      }

      return { status: 'valid', allocation: allocation, message: '' };
    }

    function defaultLidLabelsForMode(mode, packCount, prior) {
      var labels = [];
      prior = Array.isArray(prior) ? prior : [];
      for (var i = 0; i < packCount; i++) {
        if (mode === 'DOTW') {
          var keep = String(prior[i] || '').toUpperCase();
          labels.push(DOTW_ORDER.indexOf(keep) !== -1 ? keep : DOTW_ORDER[i % DOTW_ORDER.length]);
        } else if (mode === 'CUSTOM') {
          var raw = String(prior[i] || '').slice(0, LID_CUSTOM_MAX_LEN);
          labels.push(raw);
        } else {
          labels.push('');
        }
      }
      return labels;
    }

    function ensureLidLabelsLength() {
      var packCount = pickerState.packCount || 0;
      var le = pickerState.lidEngraving;
      if (!le) return;
      if (!Array.isArray(le.labels)) le.labels = [];
      if (le.labels.length !== packCount) {
        le.labels = defaultLidLabelsForMode(le.mode, packCount, le.labels);
      }
    }

    function resolveLidVariant() {
      var size = pickerState.size;
      var mode = pickerState.lidEngraving && pickerState.lidEngraving.mode || 'NONE';
      if (!size || mode === 'NONE') {
        lidVariant = null;
        return;
      }
      lidVariant = findLidVariant(size, pickerState.pocketCount || 1, mode);
    }

    function getLidVariantForMode(mode) {
      if (!pickerState.size || mode === 'NONE') return null;
      return findLidVariant(pickerState.size, pickerState.pocketCount || 1, mode);
    }

    function formatAddonButtonPrice(cents) {
      var n = parseInt(cents, 10);
      return isFinite(n) && n > 0 ? '(+' + formatPriceCents(n) + ')' : '';
    }

    function getLidModePriceLabel(mode) {
      if (mode === 'NONE') return '';
      var variant = getLidVariantForMode(mode);
      if (variant) return formatAddonButtonPrice(variant.price);
      if (pickerState.size) return 'Not available';
      return formatAddonButtonPrice(LID_MODE_FALLBACK_PRICE_CENTS[mode]);
    }

    function setModeButtonDisabled(btn, disabled) {
      btn.disabled = !!disabled;
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      btn.classList.toggle('tw:opacity-40', !!disabled);
      btn.classList.toggle('tw:cursor-not-allowed', !!disabled);
      btn.classList.toggle('tw:cursor-pointer', !disabled);
      btn.title = disabled ? 'Not available for this size.' : '';
    }

    function updateLidModePricesAndAvailability() {
      var buttons = section.querySelectorAll('[data-lid-mode]');
      for (var i = 0; i < buttons.length; i++) {
        var btn = buttons[i];
        var mode = btn.getAttribute('data-lid-mode');
        var priceEl = btn.querySelector('[data-lid-mode-price]');
        if (priceEl) priceEl.textContent = getLidModePriceLabel(mode);
        var unavailable = mode !== 'NONE' && !!pickerState.size && !getLidVariantForMode(mode);
        setModeButtonDisabled(btn, unavailable);
      }
    }

    function applyLidModeVisual() {
      var mode = pickerState.lidEngraving && pickerState.lidEngraving.mode;
      updateLidModePricesAndAvailability();
      var buttons = section.querySelectorAll('[data-lid-mode]');
      for (var i = 0; i < buttons.length; i++) {
        var btn = buttons[i];
        var isActive = !!mode && btn.getAttribute('data-lid-mode') === mode;
        btn.classList.toggle('tw:bg-black', isActive);
        btn.classList.toggle('tw:bg-white', !isActive);
        btn.classList.toggle('tw:text-white', isActive);
        btn.classList.toggle('tw:border-black', isActive);
        btn.classList.toggle('tw:border-gray-300', !isActive);
        btn.classList.toggle('tw:hover:bg-gray-50', !isActive);
      }
      var rowsEl = section.querySelector('[data-lid-rows]');
      if (rowsEl) rowsEl.classList.toggle('tw:hidden', !mode || mode === 'NONE');
      updateLidDotwWarning();
    }

    function buildEngravingSlotFrame(slotIdx) {
      var alloc = pickerState.colorAllocation && pickerState.colorAllocation[slotIdx];
      var entry = null;
      if (alloc && pickerState.size) {
        var catalog = buildColorCatalogForSize(pickerState.size);
        for (var i = 0; i < catalog.length; i++) {
          if (catalog[i].colorName === alloc.colorName) { entry = catalog[i]; break; }
        }
      }
      var frame = document.createElement('div');
      frame.className = 'tw:relative tw:w-[38px] tw:h-[38px] tw:rounded-md tw:overflow-hidden tw:border tw:border-gray-300 tw:bg-gray-50 tw:flex tw:items-center tw:justify-center tw:flex-shrink-0';
      var src = entry ? getSwatchImageSrc(entry) : '';
      if (src) {
        var img = document.createElement('img');
        img.alt = (alloc && alloc.colorName) || ('Slot ' + (slotIdx + 1));
        img.className = 'tw:w-full tw:h-full tw:object-cover';
        img.src = src;
        frame.appendChild(img);
      }
      var num = document.createElement('span');
      num.className = 'tw:absolute tw:bottom-0.5 tw:right-0.5 tw:flex tw:items-center tw:justify-center tw:w-4 tw:h-4 tw:rounded-full tw:bg-black/70 tw:text-white tw:text-[9px] tw:font-bold tw:leading-none';
      num.textContent = String(slotIdx + 1);
      frame.appendChild(num);
      return frame;
    }

    function renderLidRows() {
      var rowsEl = section.querySelector('[data-lid-rows]');
      if (!rowsEl) return;
      rowsEl.innerHTML = '';
      var packCount = pickerState.packCount || 0;
      var mode = pickerState.lidEngraving && pickerState.lidEngraving.mode || 'NONE';
      if (!packCount || mode === 'NONE') return;
      var labels = pickerState.lidEngraving.labels || [];
      for (var i = 0; i < packCount; i++) {
        var li = document.createElement('li');
        li.setAttribute('data-lid-row', '');
        li.setAttribute('data-slot-index', String(i));
        li.className = 'tw:grid tw:grid-cols-[38px_auto] tw:items-center tw:gap-2';

        li.appendChild(buildEngravingSlotFrame(i));

        var controlWrap = document.createElement('div');
        controlWrap.className = 'tw:flex-shrink-0 tw:w-full tw:md:w-32 tw:min-w-0';
        if (mode === 'DOTW') {
          controlWrap.appendChild(buildDayDropdown(i, labels[i], 'data-lid-day-select', false));
        } else {
          controlWrap.appendChild(buildCustomInput(i, labels[i], 'data-lid-custom-input', LID_CUSTOM_MAX_LEN));
        }
        li.appendChild(controlWrap);
        rowsEl.appendChild(li);
      }
    }

    function buildDayDropdown(slotIdx, currentDay, dataAttr, syncDisabled) {
      var wrap = document.createElement('div');
      wrap.className = 'tw:relative tw:w-full';
      var select = document.createElement('select');
      select.setAttribute(dataAttr, '');
      select.setAttribute('data-slot-index', String(slotIdx));
      var classes = [
        'tw:appearance-none', 'tw:w-full', 'tw:min-h-[38px]',
        'tw:m-0', 'tw:pl-3', 'tw:pr-8',
        'tw:border', 'tw:border-gray-300', 'tw:rounded-md', 'tw:text-xs',
        'tw:transition-colors', 'tw:duration-fast', 'tw:ease-standard',
        'tw:focus-visible:ring-2', 'tw:focus-visible:ring-black', 'tw:focus-visible:ring-offset-1', 'tw:focus:outline-none'
      ];
      select.style.backgroundImage = 'none';
      select.style.webkitAppearance = 'none';
      select.style.MozAppearance = 'none';
      select.style.appearance = 'none';
      if (syncDisabled) {
        select.disabled = true;
        select.setAttribute('aria-disabled', 'true');
        classes.push('tw:bg-gray-100', 'tw:text-gray-500', 'tw:cursor-not-allowed');
      } else {
        classes.push('tw:bg-white', 'tw:cursor-pointer', 'tw:hover:border-gray-400');
      }
      select.className = classes.join(' ');
      for (var d = 0; d < DOTW_ORDER.length; d++) {
        var opt = document.createElement('option');
        opt.value = DOTW_ORDER[d];
        opt.textContent = DOTW_ORDER[d];
        if (DOTW_ORDER[d] === currentDay) opt.selected = true;
        select.appendChild(opt);
      }
      wrap.appendChild(select);
      var chevron = document.createElement('span');
      chevron.setAttribute('aria-hidden', 'true');
      chevron.className = 'tw:absolute tw:top-1/2 tw:right-3 tw:-translate-y-1/2 tw:text-gray-500 tw:pointer-events-none';
      chevron.innerHTML = '<svg class="tw:w-3 tw:h-2" viewBox="0 0 12 7" fill="none"><path d="M11 1L6 6L1 1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      wrap.appendChild(chevron);
      return wrap;
    }

    function buildCustomInput(slotIdx, currentValue, dataAttr, maxLen) {
      var wrap = document.createElement('div');
      wrap.className = 'tw:relative tw:w-full';
      var input = document.createElement('input');
      input.type = 'text';
      input.setAttribute(dataAttr, '');
      input.setAttribute('data-slot-index', String(slotIdx));
      input.setAttribute('maxlength', String(maxLen));
      input.placeholder = 'Up to ' + maxLen + ' ch';
      input.value = String(currentValue || '');
      input.className = 'tw:m-0 tw:w-full tw:pl-3 tw:pr-12 tw:border tw:border-gray-300 tw:rounded-md tw:text-xs tw:bg-white tw:transition-colors tw:duration-fast tw:ease-standard tw:hover:border-gray-400 tw:focus-visible:ring-2 tw:focus-visible:ring-black tw:focus-visible:ring-offset-1 tw:focus:outline-none';
      input.setAttribute('aria-describedby', 'magnano-v2-' + dataAttr.replace(/^data-/, '') + '-counter-' + slotIdx);
      wrap.appendChild(input);
      var counter = document.createElement('span');
      counter.id = input.getAttribute('aria-describedby');
      counter.setAttribute('data-custom-counter', '');
      counter.className = 'tw:absolute tw:top-1/2 tw:right-3 tw:-translate-y-1/2 tw:text-xs tw:text-gray-500 tw:tabular-nums tw:pointer-events-none';
      counter.textContent = (input.value.length) + '/' + maxLen;
      wrap.appendChild(counter);
      return wrap;
    }

    function hasDuplicateDotwLabels(labels) {
      var seen = {};
      labels = Array.isArray(labels) ? labels : [];
      for (var i = 0; i < labels.length; i++) {
        var value = String(labels[i] || '').toUpperCase();
        if (DOTW_ORDER.indexOf(value) === -1) continue;
        if (seen[value]) return true;
        seen[value] = true;
      }
      return false;
    }

    function setDotwWarning(selector, show) {
      var el = section.querySelector(selector);
      if (!el) return;
      el.classList.toggle('tw:hidden', !show);
    }

    function updateLidDotwWarning() {
      var mode = pickerState.lidEngraving && pickerState.lidEngraving.mode || 'NONE';
      var labels = (pickerState.lidEngraving && pickerState.lidEngraving.labels) || [];
      setDotwWarning('[data-lid-dotw-warning]', mode === 'DOTW' && hasDuplicateDotwLabels(labels));
    }

    function updatePocketDotwWarning() {
      var mode = pickerState.pocketEngraving && pickerState.pocketEngraving.mode || 'NONE';
      var labels = (pickerState.pocketEngraving && pickerState.pocketEngraving.labels) || [];
      setDotwWarning('[data-pocket-dotw-warning]', POCKET_DAY_MODES.indexOf(mode) !== -1 && hasDuplicateDotwLabels(labels));
    }

    function setLidValidationMessage(message) {
      var el = section.querySelector('[data-lid-validation]');
      if (!el) return;
      if (message) {
        el.textContent = message;
        el.classList.remove('tw:hidden');
      } else {
        el.textContent = '';
        el.classList.add('tw:hidden');
      }
    }

    function validateLidEngraving() {
      var le = pickerState.lidEngraving;
      var mode = le && le.mode;
      if (!mode) return { ok: false, message: 'Please select a lid engraving option.' };
      var packCount = pickerState.packCount || 0;
      var labels = (le && le.labels) || [];
      if (labels.length !== packCount) return { ok: false, message: 'Lid labels length mismatch — please retry.' };
      if (mode === 'CUSTOM') {
        var hasCustomLidText = false;
        for (var i = 0; i < labels.length; i++) {
          if (String(labels[i] || '').trim()) hasCustomLidText = true;
        }
        if (!hasCustomLidText) {
          return { ok: false, message: 'Please enter custom lid engraving text for at least one case.' };
        }
      }
      if (mode === 'DOTW') {
        for (var i = 0; i < labels.length; i++) {
          if (DOTW_ORDER.indexOf(String(labels[i] || '').toUpperCase()) === -1) {
            return { ok: false, message: 'Slot ' + (i + 1) + ' day is invalid.' };
          }
        }
      }
      if (mode !== 'NONE' && !lidVariant) {
        return { ok: false, message: 'No lid variant available for this size and pocket count.' };
      }
      return { ok: true };
    }

    function getValidPocketModes(pocketCount) {
      return POCKET_MODES_BY_COUNT[pocketCount] || ['NONE'];
    }

    function getDefaultPocketMode(pocketCount) {
      return POCKET_DEFAULT_MODE_BY_COUNT[pocketCount] || 'NONE';
    }

    function normalizePocketMode() {
      var pe = pickerState.pocketEngraving;
      if (!pe) return;
      if (pe.mode === null) return;
      var valid = getValidPocketModes(pickerState.pocketCount || 1);
      if (valid.indexOf(pe.mode) === -1) {
        pe.mode = null;
      }
    }

    function isPocketDotwSyncAvailable() {
      var lidMode = pickerState.lidEngraving && pickerState.lidEngraving.mode;
      var pocketMode = pickerState.pocketEngraving && pickerState.pocketEngraving.mode;
      return lidMode === 'DOTW' && POCKET_DAY_MODES.indexOf(pocketMode) !== -1;
    }

    function isPocketDotwSyncActive() {
      return isPocketDotwSyncAvailable() && !!pickerState.pocketEngraving.dotwSync;
    }

    function defaultPocketLabelsForMode(mode, packCount, prior) {
      var labels = [];
      prior = Array.isArray(prior) ? prior : [];
      var syncActive = isPocketDotwSyncActive();
      var lidLabels = (pickerState.lidEngraving && pickerState.lidEngraving.labels) || [];
      for (var i = 0; i < packCount; i++) {
        if (mode === 'NONE' || mode === 'AMPM') {
          labels.push('');
        } else if (mode === 'DOTW' || mode === 'DOTW_AMPM') {
          if (syncActive) {
            var fromLid = String(lidLabels[i] || '').toUpperCase();
            labels.push(DOTW_ORDER.indexOf(fromLid) !== -1 ? fromLid : DOTW_ORDER[i % DOTW_ORDER.length]);
          } else {
            var keep = String(prior[i] || '').toUpperCase();
            labels.push(DOTW_ORDER.indexOf(keep) !== -1 ? keep : DOTW_ORDER[i % DOTW_ORDER.length]);
          }
        } else if (mode === 'CUSTOM') {
          labels.push(String(prior[i] || '').slice(0, POCKET_MAX_LEN));
        } else {
          labels.push('');
        }
      }
      return labels;
    }

    function ensurePocketLabelsLength() {
      var packCount = pickerState.packCount || 0;
      var pe = pickerState.pocketEngraving;
      if (!pe) return;
      if (!Array.isArray(pe.labels)) pe.labels = [];
      var syncActive = isPocketDotwSyncActive();
      var lidLabels = (pickerState.lidEngraving && pickerState.lidEngraving.labels) || [];
      if (pe.labels.length !== packCount || syncActive) {
        pe.labels = defaultPocketLabelsForMode(pe.mode, packCount, syncActive ? lidLabels : pe.labels);
      }
    }

    function resolvePocketVariant() {
      var size = pickerState.size;
      var mode = pickerState.pocketEngraving && pickerState.pocketEngraving.mode || 'NONE';
      if (!size || mode === 'NONE') {
        pocketVariant = null;
        return;
      }
      pocketVariant = findPocketVariant(size, pickerState.pocketCount || 1, mode);
    }

    function getPocketVariantForMode(mode) {
      if (!pickerState.size || mode === 'NONE') return null;
      return findPocketVariant(pickerState.size, pickerState.pocketCount || 1, mode);
    }

    function getPocketModePriceLabel(mode) {
      if (mode === 'NONE') return '';
      var variant = getPocketVariantForMode(mode);
      if (variant) return formatAddonButtonPrice(variant.price);
      if (pickerState.size) return 'Not available';
      return formatAddonButtonPrice(POCKET_MODE_FALLBACK_PRICE_CENTS[mode]);
    }

    function updatePocketModePricesAndAvailability() {
      var buttons = section.querySelectorAll('[data-pocket-mode]');
      for (var i = 0; i < buttons.length; i++) {
        var btn = buttons[i];
        var mode = btn.getAttribute('data-pocket-mode');
        var priceEl = btn.querySelector('[data-pocket-mode-price]');
        if (priceEl) priceEl.textContent = getPocketModePriceLabel(mode);
        var unavailable = mode !== 'NONE' && !!pickerState.size && !getPocketVariantForMode(mode);
        setModeButtonDisabled(btn, unavailable);
      }
    }

    function applyPocketModeVisual() {
      var mode = pickerState.pocketEngraving && pickerState.pocketEngraving.mode;
      updatePocketModePricesAndAvailability();
      var pocketCount = String(pickerState.pocketCount || 1);
      var buttons = section.querySelectorAll('[data-pocket-mode]');
      for (var i = 0; i < buttons.length; i++) {
        var btn = buttons[i];
        var counts = String(btn.getAttribute('data-pocket-mode-counts') || '').split(',').map(function (s) { return s.trim(); });
        var visibleForCount = counts.indexOf(pocketCount) !== -1;
        btn.classList.toggle('tw:hidden', !visibleForCount);
        var isActive = visibleForCount && !!mode && btn.getAttribute('data-pocket-mode') === mode;
        btn.classList.toggle('tw:bg-black', isActive);
        btn.classList.toggle('tw:bg-white', !isActive);
        btn.classList.toggle('tw:text-white', isActive);
        btn.classList.toggle('tw:border-black', isActive);
        btn.classList.toggle('tw:border-gray-300', !isActive);
        btn.classList.toggle('tw:hover:bg-gray-50', !isActive);
      }
      var rowsEl = section.querySelector('[data-pocket-rows]');
      if (rowsEl) rowsEl.classList.toggle('tw:hidden', !mode || mode === 'NONE');
      var syncRow = section.querySelector('[data-pocket-dotw-sync-row]');
      if (syncRow) syncRow.classList.toggle('tw:hidden', !isPocketDotwSyncAvailable());
      var syncBox = section.querySelector('[data-pocket-dotw-sync]');
      if (syncBox) syncBox.checked = !!(pickerState.pocketEngraving && pickerState.pocketEngraving.dotwSync);
      updatePocketDotwWarning();
    }

    function renderPocketRows() {
      var rowsEl = section.querySelector('[data-pocket-rows]');
      if (!rowsEl) return;
      rowsEl.innerHTML = '';
      var packCount = pickerState.packCount || 0;
      var mode = pickerState.pocketEngraving && pickerState.pocketEngraving.mode || 'NONE';
      if (!packCount || mode === 'NONE') return;
      var labels = pickerState.pocketEngraving.labels || [];
      var syncActive = isPocketDotwSyncActive();
      for (var i = 0; i < packCount; i++) {
        var li = document.createElement('li');
        li.setAttribute('data-pocket-row', '');
        li.setAttribute('data-slot-index', String(i));
        li.className = 'tw:grid tw:grid-cols-[38px_1fr] tw:items-center tw:gap-2';

        li.appendChild(buildEngravingSlotFrame(i));

        var content = document.createElement('div');
        content.className = 'tw:min-w-0';

        if (mode === 'DOTW') {
          content.appendChild(buildDayDropdown(i, labels[i], 'data-pocket-day-select', syncActive));
        } else if (mode === 'DOTW_AMPM') {
          content.className += ' tw:flex tw:items-center tw:gap-2';
          var dropdownWrap = document.createElement('div');
          dropdownWrap.className = 'tw:flex-shrink-0 tw:w-24';
          dropdownWrap.appendChild(buildDayDropdown(i, labels[i], 'data-pocket-day-select', syncActive));
          content.appendChild(dropdownWrap);
          content.appendChild(buildAmpmDayPreview(labels[i]));
        } else if (mode === 'AMPM') {
          content.appendChild(buildAmpmFixedDisplay());
        } else if (mode === 'CUSTOM') {
          content.appendChild(buildCustomInput(i, labels[i], 'data-pocket-custom-input', POCKET_MAX_LEN));
        }

        li.appendChild(content);
        rowsEl.appendChild(li);
      }
    }

    function buildAmpmFixedDisplay() {
      var wrap = document.createElement('div');
      wrap.setAttribute('data-pocket-ampm-display', '');
      wrap.className = 'tw:w-full tw:min-h-[38px] tw:flex tw:items-center tw:justify-start tw:px-3 tw:rounded-md tw:bg-gray-100 tw:border tw:border-gray-200 tw:text-sm tw:font-semibold tw:tracking-wide tw:text-gray-900';
      wrap.textContent = 'AM / PM';
      return wrap;
    }

    function renderAmpmDayPreviewText(wrap, day) {
      if (!wrap) return;
      wrap.innerHTML = '';
      var dayText = String(day || '').toUpperCase();
      [
        { text: 'AM', period: true },
        { text: dayText },
        { text: '/', separator: true },
        { text: 'PM', period: true },
        { text: dayText }
      ].forEach(function (part) {
        var span = document.createElement('span');
        if (part.period) {
          span.className = 'tw:text-[10px] tw:font-semibold tw:tracking-wide tw:text-gray-500';
        } else if (part.separator) {
          span.className = 'tw:text-sm tw:font-semibold tw:text-gray-500';
        } else {
          span.className = 'tw:text-sm tw:font-semibold tw:tracking-wide tw:text-gray-900';
        }
        span.textContent = part.text;
        wrap.appendChild(span);
      });
    }

    function buildAmpmDayPreview(day) {
      var wrap = document.createElement('div');
      wrap.setAttribute('data-pocket-ampm-preview', '');
      wrap.className = 'tw:flex-grow tw:min-w-0 tw:min-h-[38px] tw:flex tw:items-center tw:justify-start tw:gap-1 tw:px-3 tw:rounded-md tw:bg-gray-50 tw:border tw:border-gray-200 tw:overflow-hidden tw:whitespace-nowrap';
      renderAmpmDayPreviewText(wrap, day);
      return wrap;
    }

    function setPocketValidationMessage(message) {
      var el = section.querySelector('[data-pocket-validation]');
      if (!el) return;
      if (message) {
        el.textContent = message;
        el.classList.remove('tw:hidden');
      } else {
        el.textContent = '';
        el.classList.add('tw:hidden');
      }
    }

    function validatePocketEngraving() {
      var pe = pickerState.pocketEngraving;
      var mode = pe && pe.mode;
      if (!mode) return { ok: false, message: 'Please select a pocket engraving option.' };
      var packCount = pickerState.packCount || 0;
      var labels = (pe && pe.labels) || [];
      if (labels.length !== packCount) return { ok: false, message: 'Pocket labels length mismatch — please retry.' };
      if (mode === 'CUSTOM' && !labels.some(function (label) { return String(label || '').trim(); })) {
        return { ok: false, message: 'Please enter custom pocket engraving text for at least one case.' };
      }
      if (mode === 'DOTW' || mode === 'DOTW_AMPM') {
        for (var i = 0; i < labels.length; i++) {
          if (DOTW_ORDER.indexOf(String(labels[i] || '').toUpperCase()) === -1) {
            return { ok: false, message: 'Slot ' + (i + 1) + ' day is invalid.' };
          }
        }
      }
      if (mode !== 'NONE' && !pocketVariant) {
        return { ok: false, message: 'No pocket engraving variant available for this size and pocket count.' };
      }
      return { ok: true };
    }

    function formatPocketLabelForCart(mode, label) { return window.theme.magnanoSet.formatPocketLabel(mode, label); }

    function getColorLookupForSummary() {
      var catalog = pickerState.size ? buildColorCatalogForSize(pickerState.size) : [];
      var byName = {};
      catalog.forEach(function (entry) {
        if (entry && entry.colorName) byName[entry.colorName] = entry;
      });
      return byName;
    }

    function getSummaryBackgroundSrc(entry) {
      return getCaseImageSrc(entry && entry.variant) || getSwatchImageSrc(entry) || getCasePhotoSrc(entry);
    }

    function applySummaryPillBackground(pill, entry) {
      var src = getSummaryBackgroundSrc(entry);
      if (!src) return;
      var safeSrc = encodeURI(String(src)).replace(/"/g, '%22');
      pill.style.backgroundImage = 'linear-gradient(rgba(0,0,0,0.18), rgba(0,0,0,0.18)), url("' + safeSrc + '")';
      pill.style.backgroundSize = 'cover';
      pill.style.backgroundPosition = 'center';
      pill.style.color = '#fff';
      pill.style.textShadow = '0 1px 2px rgba(0,0,0,0.65)';
    }

    function applyEngravingSummaryVisibility(el, step, value) {
      if (value) {
        el.setAttribute('data-summary-value', value);
      } else {
        el.removeAttribute('data-summary-value');
      }
      el.classList.toggle('tw:hidden', !value);
    }

    function buildEngravingSummaryWrap(kind) {
      var wrap = document.createElement('span');
      wrap.setAttribute('data-mobile-summary-grid', '');
      wrap.className = kind === 'ampm'
        ? 'tw:flex tw:flex-nowrap tw:items-center tw:gap-1.5 tw:overflow-x-auto tw:align-middle'
        : 'tw:flex tw:flex-nowrap tw:items-center tw:gap-1 tw:overflow-x-auto tw:align-middle';
      return wrap;
    }

    function renderEngravingSummary(step, mode, labels) {
      var el = section.querySelector('[data-step-summary="' + step + '"]');
      if (!el) return;

      var packCount = pickerState.packCount || 0;
      labels = Array.isArray(labels) ? labels : [];
      el.innerHTML = '';
      if (!packCount) {
        el.removeAttribute('data-summary-value');
        el.classList.add('tw:hidden');
        return;
      }

      var wrap = buildEngravingSummaryWrap();
      var colorByName = getColorLookupForSummary();
      var valueParts = [];

      for (var i = 0; i < packCount; i++) {
        var alloc = pickerState.colorAllocation && pickerState.colorAllocation[i];
        var entry = alloc && colorByName[alloc.colorName];
        var text = String(labels[i] || '');
        var pill = document.createElement('span');
        pill.setAttribute('data-mobile-summary-pill', '');
        pill.className = 'tw:inline-flex tw:flex-shrink-0 tw:items-center tw:justify-center tw:min-w-[46px] tw:max-w-[120px] tw:min-h-6 tw:px-2 tw:py-1 tw:rounded-md tw:border tw:border-gray-300 tw:bg-white tw:text-xs tw:font-semibold tw:leading-none tw:truncate';
        pill.setAttribute('aria-label', 'Case ' + (i + 1) + ', ' + ((alloc && alloc.colorName) || 'selected color') + (text ? ', engraving ' + text : ', no engraving text'));
        applySummaryPillBackground(pill, entry);
        if (text) {
          pill.textContent = text;
        } else {
          pill.innerHTML = '&nbsp;';
        }
        wrap.appendChild(pill);
        valueParts.push(text || 'blank');
      }

      el.appendChild(wrap);
      applyEngravingSummaryVisibility(el, step, (mode || 'EMPTY') + ':' + valueParts.join('|'));
    }

    function applyPocketSummaryTileColor(tile, entry) {
      var src = getSummaryBackgroundSrc(entry);
      if (src) {
        var safeSrc = encodeURI(String(src)).replace(/"/g, '%22');
        tile.style.backgroundImage = 'url("' + safeSrc + '")';
        tile.style.backgroundSize = 'cover';
        tile.style.backgroundPosition = 'center';
      } else {
        tile.style.backgroundColor = '#4b5563';
      }
    }

    function buildPocketAmpmSummaryTile(mode, day, index, entry, empty) {
      var dayText = String(day || '').toUpperCase();
      var tile = document.createElement('span');
      tile.setAttribute('data-mobile-summary-tile', '');
      tile.className = 'tw:inline-flex tw:flex-shrink-0 tw:w-12 tw:h-20 tw:flex-col tw:overflow-hidden tw:rounded-md tw:border tw:border-black/20 tw:text-white tw:shadow-sm';
      tile.style.textShadow = '0 1px 1px rgba(0, 0, 0, 0.45)';
      applyPocketSummaryTileColor(tile, entry);
      var labelText = empty ? 'no pocket engraving text' : (mode === 'DOTW_AMPM' ? ('AM ' + dayText + ' / PM ' + dayText) : 'AM / PM');
      var alloc = pickerState.colorAllocation && pickerState.colorAllocation[index];
      tile.setAttribute('aria-label', 'Case ' + (index + 1) + ', ' + ((alloc && alloc.colorName) || 'selected color') + ', pocket engraving ' + labelText);

      ['AM', 'PM'].forEach(function (period, rowIndex) {
        var row = document.createElement('span');
        row.className = 'tw:flex-1 tw:w-full tw:flex tw:items-center tw:justify-center';
        row.style.backgroundColor = 'rgba(0, 0, 0, 0.32)';
        if (rowIndex > 0) row.style.borderTop = '1px solid rgba(255, 255, 255, 0.12)';
        if (empty) {
          row.innerHTML = '&nbsp;';
        } else if (mode === 'DOTW_AMPM') {
          row.className += ' tw:flex-col tw:gap-0.5';
          var periodEl = document.createElement('span');
          periodEl.className = 'tw:text-[9px] tw:font-bold tw:leading-none';
          periodEl.textContent = period;
          var dayEl = document.createElement('span');
          dayEl.className = 'tw:text-sm tw:font-semibold tw:leading-none';
          dayEl.textContent = dayText;
          row.appendChild(periodEl);
          row.appendChild(dayEl);
        } else {
          var textEl = document.createElement('span');
          textEl.className = 'tw:text-base tw:font-semibold tw:leading-none';
          textEl.textContent = period;
          row.appendChild(textEl);
        }
        tile.appendChild(row);
      });

      return tile;
    }

    function renderPocketAmpmSummary(mode, rawLabels, empty) {
      var el = section.querySelector('[data-step-summary="6"]');
      if (!el) return;
      var packCount = pickerState.packCount || 0;
      rawLabels = Array.isArray(rawLabels) ? rawLabels : [];
      el.innerHTML = '';
      if (!packCount) {
        applyEngravingSummaryVisibility(el, '6', '');
        return;
      }

      var wrap = buildEngravingSummaryWrap('ampm');
      var colorByName = getColorLookupForSummary();
      var valueParts = [];
      for (var i = 0; i < packCount; i++) {
        var day = String(rawLabels[i] || DOTW_ORDER[i % DOTW_ORDER.length]).toUpperCase();
        var alloc = pickerState.colorAllocation && pickerState.colorAllocation[i];
        var entry = alloc && colorByName[alloc.colorName];
        wrap.appendChild(buildPocketAmpmSummaryTile(mode, day, i, entry, empty));
        valueParts.push(empty ? 'blank' : (mode === 'DOTW_AMPM' ? ('AM ' + day + '/PM ' + day) : 'AM/PM'));
      }

      el.appendChild(wrap);
      applyEngravingSummaryVisibility(el, '6', (mode || 'EMPTY') + ':' + valueParts.join('|'));
    }

    function renderLidEngravingSummary() {
      var mode = pickerState.lidEngraving && pickerState.lidEngraving.mode;
      renderEngravingSummary('5', mode, (pickerState.lidEngraving && pickerState.lidEngraving.labels) || []);
    }

    function renderPocketEngravingSummary() {
      var mode = pickerState.pocketEngraving && pickerState.pocketEngraving.mode;
      var rawLabels = (pickerState.pocketEngraving && pickerState.pocketEngraving.labels) || [];
      if ((pickerState.pocketCount || 1) === 2 && (!mode || mode === 'NONE')) {
        renderPocketAmpmSummary(mode, rawLabels, true);
        return;
      }
      if (mode === 'AMPM' || mode === 'DOTW_AMPM') {
        renderPocketAmpmSummary(mode, rawLabels, false);
        return;
      }
      var labels = [];
      for (var i = 0; i < (pickerState.packCount || 0); i++) {
        labels.push(formatPocketLabelForCart(mode, rawLabels[i]));
      }
      renderEngravingSummary('6', mode, labels);
    }

    function syncPocketLabelsFromLid() {
      if (!isPocketDotwSyncActive()) return;
      var packCount = pickerState.packCount || 0;
      var lidLabels = (pickerState.lidEngraving && pickerState.lidEngraving.labels) || [];
      var pe = pickerState.pocketEngraving;
      pe.labels = [];
      for (var i = 0; i < packCount; i++) {
        pe.labels.push(String(lidLabels[i] || '').slice(0, POCKET_MAX_LEN));
      }
      if (pickerState.expandedStep === '6') renderPocketRows();
      updatePocketDotwWarning();
      if (pickerState.touchedSteps['6']) renderPocketEngravingSummary();
    }

    function onPocketSlotClick(slot) {
      var pc = parseInt(slot.getAttribute('data-pocket-slot'), 10);
      if (slot.disabled || slot.getAttribute('aria-disabled') === 'true') {
        var dispatchEntry = findDispatchEntry(pc);
        if (pc && dispatchEntry && dispatchEntry.status === 'active' && dispatchEntry.handle) {
          openNotifyModal({ pocketCount: pc });
        }
        return;
      }
      cancelUrlPrefillFromStep('1');
      if (!pc || pc === pickerState.pocketCount) return;

      pickerState.pocketCount = pc;
      pickerState.dispatchEntry = findDispatchEntry(pc);
      specSizePocketCount = 0;
      renderPocketSlots();
      setPdpTitle(pickerState.dispatchEntry && pickerState.dispatchEntry.title);
      setPdpReviews(pc);

      caseProduct = null;
      lidVariant = null;
      pocketVariant = null;
      travelVariant = null;

      resetStepsAfter('1');
      setStepLocked('2', false);
      setAtcDisabled('Pocket count changed — confirm step 1 to refetch.');

      dispatchStateEvent();
      fetchSelectedCaseProduct(false);
    }

    function onStepHeaderClick(headerBtn) {
      var step = headerBtn.getAttribute('data-step-header');
      var stepEl = getStepEl(step);
      if (!stepEl || stepEl.getAttribute('data-locked') === 'true') return;
      if (pickerState.expandedStep === step) {
        var sizeData = step === '2' ? getSizeData(pickerState.size) : null;
        if (step === '1' || step === '3' || step === '4' || (step === '2' && sizeData && !isSizeUnavailable(sizeData))) {
          cancelUrlPrefillFromStep(step);
        }
        confirmStep(step);
      } else {
        expandStep(step);
      }
    }

    function onStepConfirmClick(btn) {
      var step = btn.getAttribute('data-step-confirm');
      var sizeData = step === '2' ? getSizeData(pickerState.size) : null;
      if (step === '1' || step === '3' || step === '4' || (step === '2' && sizeData && !isSizeUnavailable(sizeData))) {
        cancelUrlPrefillFromStep(step);
      }
      confirmStep(step);
    }

    function confirmStep(step) {
      if (step === '1') {
        if (!pickerState.dispatchEntry) {
          return;
        }
        setStepTouched('1', true);
        setStepSummary('1', pickerState.pocketCount + '-Pocket');
        resetStepsAfter('1');
        setStepLocked('2', false);
        expandStep('2');
      } else if (step === '2') {
        if (!pickerState.size) {
          return;
        }
        var sizeData = getSizeData(pickerState.size);
        if (sizeData && isSizeUnavailable(sizeData)) {
          return;
        }
        setStepTouched('2', true);
        setStepSummary('2', sizeData ? (sizeData.display_name || sizeData.key) : pickerState.size);
        resetStepsAfter('2');
        resolveSizeDependentAddons();
        pickerState.packCount = computeDefaultPackCount();
        renderPackCountSlots();
        syncPreviewDefaultsForPackCount(true);
        renderProductThumbnailGallery(caseProduct);
        refreshAtc();
        setStepLocked('3', false);
        expandStep('3');
      } else if (step === '3') {
        if (!isPackCountAvailable(pickerState.packCount)) {
          return;
        }
        setStepTouched('3', true);
        setStepSummary('3', pickerState.packCount + (pickerState.packCount === 1 ? ' case' : ' cases'));
        resetStepsAfter('3');
        if (!pickerState.colorAllocation || pickerState.colorAllocation.length !== pickerState.packCount) {
          pickerState.colorAllocation = defaultColorAllocation();
        }
        renderColorSummary();
        setStepLocked('4', false);
        expandStep('4');
      } else if (step === '4') {
        var validation = validateColorAllocation();
        if (!validation.ok) {
          setColorValidationMessage(validation.message);
          return;
        }
        setColorValidationMessage('');
        setStepTouched('4', true);
        resetStepsAfter('4');
        renderColorSummary();
        refreshAtc();
        setStepLocked('5', false);
        expandStep('5');
      } else if (step === '5') {
        var lidValidation = validateLidEngraving();
        if (!lidValidation.ok) {
          setLidValidationMessage(lidValidation.message);
          return;
        }
        setLidValidationMessage('');
        setStepTouched('5', true);
        renderLidEngravingSummary();
        resetStepsAfter('5');
        refreshAtc();
        setStepLocked('6', false);
        expandStep('6');
      } else if (step === '6') {
        var pocketValidation = validatePocketEngraving();
        if (!pocketValidation.ok) {
          setPocketValidationMessage(pocketValidation.message);
          return;
        }
        setPocketValidationMessage('');
        setStepTouched('6', true);
        renderPocketEngravingSummary();
        resetStepsAfter('6');
        if (shouldHideTravelStep()) {
          syncTravelAvailabilityState();
          refreshAtc();
          collapseAll();
          pickerState.expandedStep = '';
        } else {
          setStepLocked('7', false);
          syncPreviewDefaultsForPackCount(false);
          refreshAtc();
          expandStep('7');
        }
      } else if (step === '7') {
        var travelValidation = validateTravelBox();
        if (!travelValidation.ok) {
          setTravelValidationMessage(travelValidation.message);
          return;
        }
        setTravelValidationMessage('');
        setStepTouched('7', true);
        setStepSummary('7', getTravelSummaryText());
        refreshAtc();
        collapseAll();
        pickerState.expandedStep = '';
      }
      dispatchStateEvent();
    }

    function expandStep(step) {
      collapseAll();
      setStepBodyVisible(step, true);
      setStepActive(step, true);
      pickerState.expandedStep = step;
      if (step === '2') onStep2Expand();
      if (step === '4') onStep4Expand();
      if (step === '5') onStep5Expand();
      if (step === '6') onStep6Expand();
      if (step === '7') onStep7Expand();
    }

    function onStep4Expand() {
      setColorValidationMessage('');
      renderColorRows();
    }

    function onStep5Expand() {
      setLidValidationMessage('');
      ensureLidLabelsLength();
      applyLidModeVisual();
      renderLidRows();
      renderLidEngravingSummary();
    }

    function onLidModeClick(btn) {
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      var mode = btn.getAttribute('data-lid-mode');
      if (LID_MODES.indexOf(mode) === -1) return;
      var le = pickerState.lidEngraving;
      if (le.mode === mode) return;
      var priorMode = le.mode;
      var prior = mode === 'CUSTOM' && priorMode !== 'CUSTOM' ? [] : (le.labels || []).slice();
      le.mode = mode;
      le.labels = defaultLidLabelsForMode(mode, pickerState.packCount || 0, prior);
      applyLidModeVisual();
      renderLidRows();
      setLidValidationMessage('');
      resolveLidVariant();
      updateLidDotwWarning();
      renderLidEngravingSummary();
      if (isPocketDotwSyncActive()) syncPocketLabelsFromLid();
      applyPocketModeVisual();
      if (pickerState.expandedStep === '6') renderPocketRows();
      if (pickerState.touchedSteps['6']) resetStepsAfter('5');
      if (caseProduct && pickerState.size) refreshAtc();
    }

    function onLidDayChange(select) {
      var slotIdx = parseInt(select.getAttribute('data-slot-index'), 10);
      if (isNaN(slotIdx)) return;
      var value = String(select.value || '').toUpperCase();
      if (DOTW_ORDER.indexOf(value) === -1) return;
      pickerState.lidEngraving.labels[slotIdx] = value;
      setLidValidationMessage('');
      updateLidDotwWarning();
      renderLidEngravingSummary();
      if (isPocketDotwSyncActive()) syncPocketLabelsFromLid();
      if (pickerState.touchedSteps['6']) resetStepsAfter('5');
      if (caseProduct && pickerState.size) refreshAtc();
    }

    function onLidCustomInput(input) {
      var slotIdx = parseInt(input.getAttribute('data-slot-index'), 10);
      if (isNaN(slotIdx)) return;
      var raw = String(input.value || '').slice(0, LID_CUSTOM_MAX_LEN);
      if (raw !== input.value) input.value = raw;
      pickerState.lidEngraving.labels[slotIdx] = raw;
      updateCustomInputCounter(input, LID_CUSTOM_MAX_LEN);
      setLidValidationMessage('');
      updateLidDotwWarning();
      renderLidEngravingSummary();
      if (pickerState.touchedSteps['6']) resetStepsAfter('5');
      if (caseProduct && pickerState.size) refreshAtc();
    }

    function updateCustomInputCounter(input, maxLen) {
      if (!input || !input.parentElement) return;
      var counter = input.parentElement.querySelector('[data-custom-counter]');
      if (counter) counter.textContent = (input.value || '').length + '/' + maxLen;
    }

    function onStep7Expand() {
      setTravelValidationMessage('');
      syncPreviewDefaultsForPackCount(false);
      if (shouldHideTravelStep()) {
        syncTravelAvailabilityState();
        collapseAll();
        pickerState.expandedStep = '';
        refreshAtc();
        return;
      }
      applyTravelVisual();
    }

    function onStep6Expand() {
      setPocketValidationMessage('');
      var priorMode = pickerState.pocketEngraving.mode;
      normalizePocketMode();
      if (pickerState.pocketEngraving.mode !== priorMode) {
        pickerState.pocketEngraving.labels = defaultPocketLabelsForMode(
          pickerState.pocketEngraving.mode,
          pickerState.packCount || 0,
          pickerState.pocketEngraving.labels
        );
        resolvePocketVariant();
      }
      ensurePocketLabelsLength();
      applyPocketModeVisual();
      renderPocketRows();
      renderPocketEngravingSummary();
    }

    function onPocketModeClick(btn) {
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      var mode = btn.getAttribute('data-pocket-mode');
      var validModes = getValidPocketModes(pickerState.pocketCount || 1);
      if (validModes.indexOf(mode) === -1) return;
      var pe = pickerState.pocketEngraving;
      if (pe.mode === mode) return;
      var priorMode = pe.mode;
      var prior = mode === 'CUSTOM' && priorMode !== 'CUSTOM' ? [] : (pe.labels || []).slice();
      pe.mode = mode;
      pe.labels = defaultPocketLabelsForMode(mode, pickerState.packCount || 0, prior);
      applyPocketModeVisual();
      renderPocketRows();
      setPocketValidationMessage('');
      resolvePocketVariant();
      updatePocketDotwWarning();
      renderPocketEngravingSummary();
      if (pickerState.touchedSteps['7']) resetStepsAfter('6');
      if (caseProduct && pickerState.size) refreshAtc();
    }

    function onPocketDotwSyncChange(checkbox) {
      if (!isPocketDotwSyncAvailable()) return;
      var pe = pickerState.pocketEngraving;
      pe.dotwSync = !!checkbox.checked;
      if (pe.dotwSync) {
        syncPocketLabelsFromLid();
      }
      applyPocketModeVisual();
      renderPocketRows();
      updatePocketDotwWarning();
      renderPocketEngravingSummary();
      if (pickerState.touchedSteps['7']) resetStepsAfter('6');
      if (caseProduct && pickerState.size) refreshAtc();
    }

    function onPocketCustomInput(input) {
      var slotIdx = parseInt(input.getAttribute('data-slot-index'), 10);
      if (isNaN(slotIdx)) return;
      var raw = String(input.value || '').slice(0, POCKET_MAX_LEN);
      if (raw !== input.value) input.value = raw;
      pickerState.pocketEngraving.labels[slotIdx] = raw;
      updateCustomInputCounter(input, POCKET_MAX_LEN);
      setPocketValidationMessage('');
      updatePocketDotwWarning();
      renderPocketEngravingSummary();
      if (pickerState.touchedSteps['7']) resetStepsAfter('6');
      if (caseProduct && pickerState.size) refreshAtc();
    }

    function isTravelAvailabilityResolved() {
      return !!(pickerState.touchedSteps && pickerState.touchedSteps['2'] && pickerState.size);
    }

    function isTravelVariantAvailable() {
      return isTravelVariantInStock(travelVariant);
    }

    function shouldHideTravelStep() {
      return isTravelAvailabilityResolved() && !isTravelVariantAvailable();
    }

    function clearTravelSelection() {
      if (!pickerState.travelBox) return;
      pickerState.travelBox.selected = false;
      pickerState.travelBox.variantId = null;
    }

    function syncTravelAvailabilityState() {
      if (!pickerState.travelBox) return true;
      var hideStep = shouldHideTravelStep();
      setStepHidden('7', hideStep);
      if (hideStep) {
        clearTravelSelection();
        pickerState.travelBox.skippedUnavailable = true;
        setTravelValidationMessage('');
        setStepSummary('7', '');
        setStepTouched('7', true);
        setStepLocked('7', true);
        applyTravelVisual();
        return false;
      }

      if (pickerState.travelBox.skippedUnavailable) {
        pickerState.travelBox.skippedUnavailable = false;
        clearTravelSelection();
        if (pickerState.touchedSteps['7']) {
          setStepTouched('7', false);
          setStepSummary('7', '');
        }
      }
      return true;
    }

    function syncTravelDefaultSelection() {
      if (!pickerState.travelBox) return;
      if (!isTravelVariantAvailable()) {
        clearTravelSelection();
        return;
      }
      if (!pickerState.touchedSteps['7']) {
        pickerState.travelBox.selected = isTravelFree();
      }
      pickerState.travelBox.variantId = pickerState.travelBox.selected ? String(travelVariant.id) : null;
    }

    function isTravelFree() {
      return pickerState.packCount === 7;
    }

    function getTravelPriceLabel() {
      if (!isTravelVariantAvailable()) return 'Unavailable';
      if (isTravelFree()) return 'Free with 7-pack';
      return '+' + formatPriceCents(travelVariant.price);
    }

    function getTravelButtonPriceText() {
      if (!isTravelVariantAvailable()) return '(Unavailable)';
      if (isTravelFree()) return '(Free! $15 Value)';
      return '(+' + formatPriceCents(travelVariant.price) + ')';
    }

    function getTravelSummaryText() {
      return pickerState.travelBox && pickerState.travelBox.selected
        ? 'Yes, Please ' + getTravelButtonPriceText()
        : 'No, Thanks';
    }

    function applyTravelVisual() {
      var selected = !!(pickerState.travelBox && pickerState.travelBox.selected);
      var btnNo = section.querySelector('[data-travel-option="no"]');
      var btnYes = section.querySelector('[data-travel-option="yes"]');
      [{ btn: btnNo, isActive: !selected }, { btn: btnYes, isActive: selected }].forEach(function (entry) {
        if (!entry.btn) return;
        entry.btn.classList.toggle('tw:bg-black', entry.isActive);
        entry.btn.classList.toggle('tw:bg-white', !entry.isActive);
        entry.btn.classList.toggle('tw:text-white', entry.isActive);
        entry.btn.classList.toggle('tw:border-black', entry.isActive);
        entry.btn.classList.toggle('tw:border-gray-300', !entry.isActive);
        entry.btn.classList.toggle('tw:hover:bg-gray-50', !entry.isActive);
      });
      var unavailable = !isTravelVariantAvailable();
      var priceEl = section.querySelector('[data-travel-price]');
      if (priceEl) {
        priceEl.textContent = getTravelButtonPriceText();
      }
      if (btnYes) {
        btnYes.disabled = !!unavailable;
        if (unavailable) {
          btnYes.setAttribute('aria-disabled', 'true');
        } else {
          btnYes.removeAttribute('aria-disabled');
        }
      }
      if (pickerState.touchedSteps['7']) setStepSummary('7', getTravelSummaryText());
    }

    function setTravelValidationMessage(message) {
      var el = section.querySelector('[data-travel-validation]');
      if (!el) return;
      if (message) {
        el.textContent = message;
        el.classList.remove('tw:hidden');
      } else {
        el.textContent = '';
        el.classList.add('tw:hidden');
      }
    }

    function validateTravelBox() {
      if (!pickerState.travelBox.selected) return { ok: true };
      if (!isTravelVariantAvailable()) {
        return { ok: false, message: 'No travel box variant available for this size and pocket count.' };
      }
      return { ok: true };
    }

    function onTravelOptionClick(btn) {
      if (btn.disabled) return;
      var newSelected = btn.getAttribute('data-travel-option') === 'yes';
      if (newSelected && !isTravelVariantAvailable()) return;
      if (pickerState.travelBox.selected === newSelected) return;
      pickerState.travelBox.selected = newSelected;
      pickerState.travelBox.variantId = (newSelected && travelVariant) ? String(travelVariant.id) : null;
      applyTravelVisual();
      setTravelValidationMessage('');
      if (caseProduct && pickerState.size) refreshAtc();
    }

    function onPocketDaySelectChange(select) {
      if (isPocketDotwSyncActive()) return;
      var slotIdx = parseInt(select.getAttribute('data-slot-index'), 10);
      if (isNaN(slotIdx)) return;
      var value = String(select.value || '').toUpperCase();
      if (DOTW_ORDER.indexOf(value) === -1) return;
      pickerState.pocketEngraving.labels[slotIdx] = value;
      var row = select.closest('[data-pocket-row]');
      if (row) {
        var preview = row.querySelector('[data-pocket-ampm-preview]');
        if (preview) {
          renderAmpmDayPreviewText(preview, value);
        }
      }
      setPocketValidationMessage('');
      updatePocketDotwWarning();
      renderPocketEngravingSummary();
      if (pickerState.touchedSteps['7']) resetStepsAfter('6');
      if (caseProduct && pickerState.size) refreshAtc();
    }

    function fetchSelectedCaseProduct(renderSizesAfterFetch, force) {
      if (!pickerState.dispatchEntry || !pickerState.dispatchEntry.handle) return Promise.resolve(null);
      var handle = pickerState.dispatchEntry.handle;
      var pocketCount = parseInt(pickerState.pocketCount || pickerState.dispatchEntry.pocketCount, 10) || 1;
      var fetchArgs = ['magnano', handle, pocketCount, listingContext];
      if (!force && caseProduct && caseProduct.handle === handle && (parseInt(caseProduct.pocket_count, 10) || 1) === pocketCount && hasMatchingListingContext(caseProduct)) {
        renderProductThumbnailGallery(caseProduct);
        if (renderSizesAfterFetch) renderSizeRows();
        return Promise.resolve(caseProduct);
      }

      if (force && theme.productDataFetcher && typeof theme.productDataFetcher.invalidate === 'function') {
        theme.productDataFetcher.invalidate.apply(theme.productDataFetcher, fetchArgs);
      }

      return theme.productDataFetcher.fetch.apply(theme.productDataFetcher, fetchArgs).then(function (data) {
        if (!pickerState.dispatchEntry || pickerState.dispatchEntry.handle !== handle || (parseInt(pickerState.pocketCount, 10) || 1) !== pocketCount) {
          return null;
        }
        if (!data || data.error || !hasMatchingListingContext(data)) {
          if (renderSizesAfterFetch) setStep2Error('Fetch error: ' + JSON.stringify(data));
          console.warn('[magnano-v2] Product data fetch failed:', data);
          return null;
        }
        caseProduct = data;
        notifyProductsByPocketCount[pocketCount] = data;
        setPdpTitle(caseProduct.title);
        renderProductThumbnailGallery(caseProduct);
        if (renderSizesAfterFetch) renderSizeRows();
        return caseProduct;
      });
    }

    function applyPendingUrlSizePrefill(data, run) {
      var prefill = pickerState.urlPrefill;
      if (!prefill || !prefill.hasSize || prefill.sizeStatus !== 'pending' || run !== urlPrefillRun) return;
      if (!data || data !== caseProduct || !data.sizes) return;

      var size = resolveSizePrefill(prefill.rawSize, data.sizes);
      if (!size) {
        pickerState.size = null;
        specSizePocketCount = 0;
        prefill.resolvedSizeKey = null;
        setUrlPrefillStatus('size', 'unknown');
        setSizeValidationMessage('Requested case size ' + requestedValueLabel(prefill.rawSize) + ' is not available for this pocket count. Please choose an available size.');
        refreshSizeRowsSelection();
        dispatchStateEvent();
        return;
      }

      prefill.resolvedSizeKey = size.key;
      pickerState.size = size.key;
      specSizePocketCount = pickerState.pocketCount;
      if (isSizeUnavailable(size)) {
        setUrlPrefillStatus('size', 'sold_out');
        setSizeValidationMessage(isSizeColorCatalogEmpty(size)
          ? 'No colors are available for this selection.'
          : 'Requested case size ' + requestedValueLabel(prefill.rawSize) + ' is currently unavailable. Please choose another size or use Notify When Back In Stock.');
        refreshSizeRowsSelection();
        dispatchStateEvent();
        return;
      }

      setUrlPrefillStatus('size', 'valid');
      setSizeValidationMessage('');
      resolveSizeDependentAddons();
      refreshSizeRowsSelection();
      confirmStep('2');
      applyPendingUrlColorPrefill(run);
    }

    function applyPendingUrlColorPrefill(run) {
      var prefill = pickerState.urlPrefill;
      if (!prefill || !prefill.hasColor || prefill.colorStatus !== 'pending' || run !== urlPrefillRun) return;
      if (!caseProduct || !pickerState.size || !pickerState.touchedSteps['2']) return;
      if (cartReservationsPromise && !cartReservationsLoaded) {
        cartReservationsPromise.then(function () { applyPendingUrlColorPrefill(run); });
        return;
      }

      if (!isPackCountAvailable(MAX_PACK_COUNT)) {
        setUrlPrefillStatus('color', 'sold_out');
        setPackValidationMessage('The requested seven-case selection is not currently available for this pocket count and size. Please choose an available quantity.');
        dispatchStateEvent();
        return;
      }

      setPackValidationMessage('');
      pickerState.packCount = MAX_PACK_COUNT;
      renderPackCountSlots();
      syncPreviewDefaultsForPackCount(true);
      confirmStep('3');

      var resolved = resolveUrlColorPrefill(prefill.rawColor);
      setUrlPrefillStatus('color', resolved.status);
      if (resolved.allocation) pickerState.colorAllocation = resolved.allocation;
      renderColorRows();

      if (resolved.status !== 'valid') {
        setColorValidationMessage(resolved.message);
        refreshAtc();
        dispatchStateEvent();
        return;
      }

      setColorValidationMessage('');
      confirmStep('4');
    }

    function applyUrlPrefill() {
      var prefill = pickerState.urlPrefill;
      if (!prefill) return false;
      if (prefill.hasPockets && prefill.pocketStatus !== 'valid') return false;
      urlPrefillRun += 1;
      setPocketCountValidationMessage('');
      confirmStep('1');
      return true;
    }

    function onStep2Expand(force) {
      if (!pickerState.dispatchEntry) {
        setStep2Error('No dispatch entry. Aborting.');
        return Promise.resolve(null);
      }

      var handle = pickerState.dispatchEntry.handle;
      var run = urlPrefillRun;
      if (!force && caseProduct && caseProduct.handle === handle && hasMatchingListingContext(caseProduct)) {
        renderProductThumbnailGallery(caseProduct);
        renderSizeRows();
        applyPendingUrlSizePrefill(caseProduct, run);
        return Promise.resolve(caseProduct);
      }

      setStep2State('loading');
      return fetchSelectedCaseProduct(true, force).then(function (data) {
        applyPendingUrlSizePrefill(data, run);
        return data;
      }).catch(function (err) {
        setStep2Error('Unable to load sizes. Please try again.');
        console.warn('[magnano-v2] Product data request failed:', err);
        return null;
      });
    }

    function onSizeRowClick(row) {
      var key = row.getAttribute('data-size-key');
      if (row.getAttribute('aria-disabled') === 'true') {
        var unavailableSize = getSizeData(key);
        if (isSizeColorCatalogEmpty(unavailableSize)) {
          setSizeValidationMessage('No colors are available for this selection.');
          return;
        }
        openNotifyModal({ pocketCount: pickerState.pocketCount, caseSize: key });
        return;
      }
      cancelUrlPrefillFromStep('2');
      if (!key || key === pickerState.size) return;
      pickerState.size = key;
      specSizePocketCount = pickerState.pocketCount;
      if (pickerState.touchedSteps['3'] || pickerState.touchedSteps['4']) {
        resetStepsAfter('2');
      }
      resolveSizeDependentAddons();
      refreshSizeRowsSelection();
      renderProductThumbnailGallery(caseProduct);
      dispatchStateEvent();
    }

    function onColorOptionClick(option) {
      var slotIdx = parseInt(option.getAttribute('data-slot-index'), 10);
      if (isNaN(slotIdx)) return;
      var colorName = option.getAttribute('data-color-option');
      if (!colorName) return;
      cancelUrlPrefillFromStep('4');
      var catalog = buildColorCatalogForSize(pickerState.size);
      var entry = catalog.find(function (c) { return c.colorName === colorName; });
      if (!entry) return;
      var popup = section.querySelector('[data-color-popup][data-slot-index="' + slotIdx + '"]');
      if (option.getAttribute('aria-disabled') === 'true') {
        var isSoldOutColor = getNotifyColorChoices(caseProduct, pickerState.size).some(function (color) {
          return ciEquals(color.value, colorName);
        });
        if (isSoldOutColor) {
          if (popup && typeof popup.hidePopover === 'function' && popup.matches(':popover-open')) {
            popup.hidePopover();
          }
          openNotifyModal({ pocketCount: pickerState.pocketCount, caseSize: pickerState.size, color: colorName });
        }
        return;
      }

      if (popup && typeof popup.hidePopover === 'function' && popup.matches(':popover-open')) {
        popup.hidePopover();
      }

      if (pickerState.colorAllocation[slotIdx] && pickerState.colorAllocation[slotIdx].colorName === colorName) {
        return;
      }

      pickerState.colorAllocation[slotIdx] = {
        slot: slotIdx + 1,
        variantId: String(entry.variant.id),
        colorName: colorName
      };

      var row = section.querySelector('[data-color-row][data-slot-index="' + slotIdx + '"]');
      if (row) {
        var swatchSrc = getSwatchImageSrc(entry);
        var rowImg = row.querySelector('[data-color-row-image]');
        if (rowImg) {
          rowImg.alt = entry.colorName;
          if (swatchSrc) rowImg.src = swatchSrc;
        }
        updateColorTriggerPhoto(row, entry);
        var triggerName = row.querySelector('[data-color-trigger-name]');
        if (triggerName) triggerName.textContent = colorName;
        updateColorTriggerBadges(row, entry);
      }

      refreshColorOptions();
      renderColorSummary();
      setColorValidationMessage('');

      if (pickerState.touchedSteps['5']) resetStepsAfter('4');

      if (caseProduct && pickerState.size) refreshAtc();

    }

    function onPackOptionClick(option) {
      if (option.getAttribute('aria-disabled') === 'true') return;
      var n = parseInt(option.getAttribute('data-pack-option'), 10);
      if (!n) return;
      cancelUrlPrefillFromStep('3');
      var popup = section.querySelector('[data-pack-popup]');
      if (popup && typeof popup.hidePopover === 'function' && popup.matches(':popover-open')) {
        popup.hidePopover();
      }
      if (n === pickerState.packCount) return;
      pickerState.packCount = n;
      if (pickerState.touchedSteps['4']) {
        resetStepsAfter('3');
      }
      renderPackCountSlots();
      syncPreviewDefaultsForPackCount(true);
      if (caseProduct && pickerState.size) refreshAtc();
      else dispatchStateEvent();
    }

    function getImageSrcValue(image) {
      if (!image) return '';
      if (typeof image === 'string') return image;
      return image.src || image.url || getImageSrcValue(image.preview_image) || '';
    }

    function findProductImageById(product, imageId) {
      if (!product || !imageId) return null;
      var images = product.images || [];
      for (var i = 0; i < images.length; i++) {
        if (String(images[i] && images[i].id) === String(imageId)) return images[i];
      }
      return null;
    }

    function getTravelPreviewImageSrc() {
      var variantSrc = travelVariant
        ? getImageSrcValue(
            travelVariant.featured_image
            || travelVariant.image
            || travelVariant.featured_media
            || findProductImageById(travelProduct, travelVariant.image_id)
          )
        : '';
      if (variantSrc) return variantSrc;
      return travelProduct ? getImageSrcValue(travelProduct.featured_image) : '';
    }

    function ensureTravelPreviewImage(layer) {
      var img = layer && layer.querySelector('[data-preview-travel-img]');
      if (img || !layer) return img;
      img = document.createElement('img');
      img.setAttribute('data-preview-travel-img', '');
      img.alt = '';
      img.loading = 'lazy';
      img.className = 'tw:w-full tw:h-full tw:object-contain';
      layer.appendChild(img);
      return img;
    }

    function normalizePreviewImageSrc(src, width) {
      src = String(src || '');
      if (!src) return '';
      if (src.indexOf('{width}') !== -1) return src.replace('{width}', String(width || 1000));
      return src;
    }

    function updateTravelPreviewImage() {
      var layers = section.querySelectorAll('[data-preview-layer="travel"]');
      if (!isTravelVariantAvailable()) {
        for (var h = 0; h < layers.length; h++) layers[h].classList.add('tw:hidden');
        return;
      }
      var src = getTravelPreviewImageSrc();
      if (!src) return;
      for (var i = 0; i < layers.length; i++) {
        var img = ensureTravelPreviewImage(layers[i]);
        if (!img) continue;
        var preview = layers[i].closest('[data-composite-preview]');
        var width = preview && preview.getAttribute('data-preview-size') === 'thumb' ? 200 : 1000;
        var nextSrc = normalizePreviewImageSrc(src, width) || src;
        if (img.getAttribute('src') !== nextSrc) img.setAttribute('src', nextSrc);
      }
    }

    // Gallery images come only from the size's Case Specs entry. With no size picked
    // yet, use the default size's gallery, as the section's first paint does.
    function getMagnanoThumbnailImages(productData, sizeKey) {
      var sizes = productData && Array.isArray(productData.sizes) ? productData.sizes : [];
      var sizeData = sizeKey
        ? sizes.find(function (size) { return size && size.key === sizeKey; })
        : sizes.find(function (size) { return !isSizeUnavailable(size); });
      var images = sizeData && sizeData.gallery_images;
      if (!Array.isArray(images)) return [];
      return images.filter(function (image) {
        return image && (image.src || image.thumb);
      });
    }

    function updateInitialGalleryImage(image) {
      var initLayers = section.querySelectorAll('[data-preview-layer="init"]');
      for (var i = 0; i < initLayers.length; i++) {
        var layer = initLayers[i];
        var img = layer.querySelector('[data-preview-init]');
        var preview = layer.closest('[data-composite-preview]');
        var useThumb = preview && preview.getAttribute('data-preview-size') === 'thumb';
        var src = image ? (useThumb ? (image.thumb || image.src) : (image.src || image.thumb)) : '';
        if (!src) {
          if (img) {
            img.removeAttribute('src');
            img.alt = '';
          }
          layer.classList.add('tw:hidden');
          continue;
        }
        if (!img) {
          img = document.createElement('img');
          img.setAttribute('data-preview-init', '');
          img.loading = 'lazy';
          img.className = 'tw:w-full tw:h-full tw:object-contain';
          layer.appendChild(img);
        }
        if (img.getAttribute('src') !== src) img.setAttribute('src', src);
        img.alt = image ? (image.alt || '') : '';
        layer.classList.remove('tw:hidden');
        layer.classList.remove('tw:opacity-0');
      }
    }

    function getGalleryFirstSlideMode() {
      return pickerState.touchedSteps && pickerState.touchedSteps['2'] && pickerState.size ? 'composite' : 'product';
    }

    function clearProductThumbnailGallery() {
      if (galleryThumbsEl) {
        galleryThumbsEl.querySelectorAll('[data-gallery-thumb-dynamic]').forEach(function (el) {
          el.parentNode.removeChild(el);
        });
      }
      if (galleryStageEl) {
        galleryStageEl.querySelectorAll('[data-gallery-slide-dynamic]').forEach(function (el) {
          el.parentNode.removeChild(el);
        });
      }
    }

    function createProductGalleryThumb(image, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('data-gallery-thumb', '');
      button.setAttribute('data-gallery-thumb-dynamic', '');
      button.setAttribute('data-slide-target', String(index));
      button.setAttribute('data-active', 'false');
      button.setAttribute('aria-label', 'Slide ' + (index + 1));
      button.className = 'tw:relative tw:aspect-square tw:w-16 tw:lg:w-20 tw:flex-shrink-0 tw:overflow-hidden tw:rounded-md tw:border tw:border-gray-200 tw:bg-gray-50 tw:cursor-pointer tw:transition-all tw:duration-fast tw:ease-standard tw:data-[active=true]:ring-2 tw:data-[active=true]:ring-black tw:data-[active=true]:ring-offset-1 tw:hover:border-gray-400';

      var img = document.createElement('img');
      img.src = image.thumb || image.src;
      img.alt = image.alt || '';
      img.loading = 'lazy';
      img.className = 'tw:absolute tw:inset-0 tw:w-full tw:h-full tw:object-contain';
      button.appendChild(img);
      return button;
    }

    function createProductGallerySlide(image, index) {
      var slide = document.createElement('div');
      slide.setAttribute('data-gallery-slide', '');
      slide.setAttribute('data-gallery-slide-dynamic', '');
      slide.setAttribute('data-slide-index', String(index));
      slide.setAttribute('data-slide-type', 'image');
      slide.setAttribute('data-active', 'false');
      slide.className = 'tw:absolute tw:inset-0 tw:opacity-0 tw:pointer-events-none tw:transition-opacity tw:duration-base tw:ease-standard tw:data-[active=true]:opacity-100 tw:data-[active=true]:pointer-events-auto';

      var img = document.createElement('img');
      img.src = image.src || image.thumb;
      img.alt = image.alt || '';
      img.loading = 'lazy';
      img.className = 'tw:w-full tw:h-full tw:object-contain';
      slide.appendChild(img);
      return slide;
    }

    function renderProductThumbnailGallery(productData) {
      var productHandle = productData && productData.handle ? productData.handle : '';
      var pocketCount = parseInt(productData && productData.pocket_count, 10) || 0;
      var sizeKey = pickerState.size || '';
      var firstSlideMode = getGalleryFirstSlideMode();
      if (productHandle && galleryProductHandle === productHandle && galleryPocketCount === pocketCount && gallerySizeKey === sizeKey && galleryFirstSlideMode === firstSlideMode) {
        updateGalleryNavButtons(galleryStageEl ? galleryStageEl.querySelectorAll('[data-gallery-slide]').length : 0);
        return;
      }
      galleryProductHandle = productHandle;
      galleryPocketCount = pocketCount;
      gallerySizeKey = sizeKey;
      galleryFirstSlideMode = firstSlideMode;
      clearProductThumbnailGallery();
      var images = getMagnanoThumbnailImages(productData, sizeKey);
      updateInitialGalleryImage(firstSlideMode === 'product' ? images[0] : null);
      images.forEach(function (image, i) {
        if (firstSlideMode === 'product' && i === 0) return;
        var slideIndex = firstSlideMode === 'composite' ? i + 1 : i;
        if (galleryThumbsEl) galleryThumbsEl.appendChild(createProductGalleryThumb(image, slideIndex));
        if (galleryStageEl) galleryStageEl.insertBefore(createProductGallerySlide(image, slideIndex), galleryPrevBtn || null);
      });
      setActiveSlide(0);
    }

    function resolveSizeDependentAddons() {
      var size = pickerState.size;
      if (!size) return;
      lidVariant = null;
      pocketVariant = null;
      travelVariant = null;
      resolveLidVariant();
      resolvePocketVariant();
      updateLidModePricesAndAvailability();
      updatePocketModePricesAndAvailability();
      refreshTravelState();
    }

    function refreshTravelState() {
      travelVariant = findTravelVariant(pickerState.size, pickerState.pocketCount || 1);
      syncTravelAvailabilityState();
      syncTravelDefaultSelection();
      updateTravelPreviewImage();
      applyTravelVisual();
    }

    function isAtcReady() {
      var t = pickerState.touchedSteps;
      return !!(t['1'] && t['2'] && t['3'] && t['4'] && t['5'] && t['6'] && t['7']);
    }

    function computePresentmentTotals() {
      var packCount = pickerState.packCount || 0;
      if (packCount < 1) {
        return { totalCents: 0, compareAtCents: 0, hasPriceBasis: false };
      }
      var tier = findTierVariant(packCount, pickerState.pocketCount, pickerState.size);
      if (!tier) {
        return { totalCents: 0, compareAtCents: 0, hasPriceBasis: false };
      }
      var tierPrice = parseInt(tier.price, 10) || 0;
      var tierCompare = parseInt(tier.compare_at_price, 10) || tierPrice;
      var baseCompare = tierCompare > tierPrice ? tierCompare : tierPrice;

      var lidMode = (pickerState.lidEngraving && pickerState.lidEngraving.mode) || 'NONE';
      var pocketMode = (pickerState.pocketEngraving && pickerState.pocketEngraving.mode) || 'NONE';
      var travelOn = !!(pickerState.travelBox && pickerState.travelBox.selected && isTravelVariantAvailable());

      var lidPrice    = (lidVariant && lidMode !== 'NONE')       ? (parseInt(lidVariant.price, 10) || 0)    : 0;
      var pocketPrice = (pocketVariant && pocketMode !== 'NONE') ? (parseInt(pocketVariant.price, 10) || 0) : 0;
      var travelPrice = (travelVariant && travelOn)              ? (parseInt(travelVariant.price, 10) || 0) : 0;
      var paidTravel  = packCount === 7 ? 0 : travelPrice;

      return {
        totalCents:     tierPrice    + lidPrice + pocketPrice + paidTravel,
        compareAtCents: baseCompare  + lidPrice + pocketPrice + travelPrice,
        hasPriceBasis:  true
      };
    }

    function updateGalleryNavButtons(totalSlides) {
      if (!galleryPrevBtn || !galleryNextBtn) return;
      var hasMultipleSlides = totalSlides > 1;
      galleryPrevBtn.disabled = !hasMultipleSlides || activeSlideIndex <= 0;
      galleryNextBtn.disabled = !hasMultipleSlides || activeSlideIndex >= totalSlides - 1;
    }

    function setActiveSlide(idx) {
      if (!galleryStageEl || !galleryThumbsEl) return;
      var slides = galleryStageEl.querySelectorAll('[data-gallery-slide]');
      var thumbs = galleryThumbsEl.querySelectorAll('[data-gallery-thumb]');
      if (!slides.length) return;
      if (idx < 0) idx = 0;
      if (idx >= slides.length) idx = slides.length - 1;
      activeSlideIndex = idx;
      slides.forEach(function (slide) {
        var i = parseInt(slide.getAttribute('data-slide-index'), 10);
        slide.setAttribute('data-active', i === idx ? 'true' : 'false');
      });
      thumbs.forEach(function (thumb) {
        var t = parseInt(thumb.getAttribute('data-slide-target'), 10);
        var isActive = t === idx;
        thumb.setAttribute('data-active', isActive ? 'true' : 'false');
        if (isActive) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      updateGalleryNavButtons(slides.length);
    }

    function onGalleryThumbClick(thumb) {
      var target = parseInt(thumb.getAttribute('data-slide-target'), 10);
      if (isFinite(target)) setActiveSlide(target);
    }

    function onGalleryNavClick(navBtn) {
      var dir = navBtn.getAttribute('data-gallery-nav') === 'next' ? 1 : -1;
      setActiveSlide(activeSlideIndex + dir);
    }

    function getCaseImageSrc(variant) {
      var resolver = window.theme && window.theme.caseImages;
      if (!variant || !resolver) return '';
      return resolver.resolve(caseImagesByColor, {
        colorKey: variant.option2,
        sizeKey: variant.option1,
        pockets: caseProduct && caseProduct.pocket_count
          || pickerState.dispatchEntry && pickerState.dispatchEntry.pocketCount
      });
    }

    function getCasePreviewImageSrc(variant) {
      if (!variant) return '';
      var caseImage = getCaseImageSrc(variant);
      if (caseImage) return caseImage;
      if (variant.case_color && variant.case_color.swatch_image) return variant.case_color.swatch_image;
      return '';
    }

    function getPreviewLidText(detail, index) {
      var lid = detail && detail.lidEngraving ? detail.lidEngraving : {};
      var mode = String(lid.mode || 'NONE').toUpperCase();
      if (mode === 'NONE') return '';
      if (!detail || !detail.addonVariantIds || !detail.addonVariantIds.lid) return '';

      var labels = Array.isArray(lid.labels) ? lid.labels : [];
      if (mode === 'DOTW') {
        var day = String(labels[index] || '').toUpperCase();
        return DOTW_ORDER.indexOf(day) !== -1 ? day : DOTW_ORDER[index % DOTW_ORDER.length];
      }

      if (mode === 'CUSTOM') {
        return String(labels[index] || '').slice(0, LID_CUSTOM_MAX_LEN);
      }

      return '';
    }

    function setPreviewLidText(slot, text) {
      var normalized = String(text || '');
      slot.setAttribute('data-lid-text', normalized);
      var textEl = slot.querySelector('[data-preview-lid-text]');
      if (!textEl) return;
      textEl.textContent = normalized;
      textEl.classList.toggle('tw:hidden', !normalized);
      textEl.classList.toggle('tw:flex', !!normalized);
    }

    function renderCompositePreview(detail) {
      if (!compositePreviewEls || !compositePreviewEls.length) return;
      var alloc = (detail && detail.colorAllocation) || [];
      var size = detail && detail.size;
      var pocketCount = detail && detail.pocketCount;
      var packCount = detail && detail.packCount ? parseInt(detail.packCount, 10) || 0 : 0;
      var caseWidth = 111;
      var maxCaseWidth = 130;
      if (parseInt(pocketCount, 10) === 1 && ciIncludes(size, 'vitamin') && !ciIncludes(size, 'xl')) {
        caseWidth = 130;
      } else if (parseInt(pocketCount, 10) === 2) {
        caseWidth = 121;
      }
      var hasCompositeSelection = Boolean(size && packCount > 0);
      var travelOn = hasCompositeSelection && detail && detail.travelSelected === 'yes';
      if (travelOn) updateTravelPreviewImage();

      if (!hasCompositeSelection) {
        alloc = [];
      } else if ((!alloc.length || alloc.length !== packCount) && caseProduct) {
        alloc = defaultColorAllocation();
      }

      for (var c = 0; c < compositePreviewEls.length; c++) {
        var container = compositePreviewEls[c];
        var previewTravelEl = container.querySelector('[data-preview-layer="travel"]');
        var previewInitEl = container.querySelector('[data-preview-layer="init"]');
        var previewCaseGrid = container.querySelector('[data-preview-case-grid]');
        var previewCasesEls = container.querySelectorAll('[data-preview-case]');
        var pocketBgImgEls = container.querySelectorAll('[data-pocket-preview-image]');

        if (previewCaseGrid && previewCasesEls.length) {
          previewCaseGrid.style.width = (caseWidth / maxCaseWidth * 100) + '%';
          previewCaseGrid.style.gridTemplateColumns = 'repeat(' + previewCasesEls.length + ', minmax(0, 1fr))';
        }

        if (pocketBgImgEls && pocketBgImgEls.length) {
          for (var b = 0; b < pocketBgImgEls.length; b++) {
            var bgImg = pocketBgImgEls[b];
            var bgPc = parseInt(bgImg.getAttribute('data-pocket-preview-image'), 10);
            bgImg.classList.toggle('tw:hidden', bgPc !== pocketCount);
          }
        }

        if (previewTravelEl) previewTravelEl.classList.toggle('tw:hidden', !travelOn);

        var paintedAny = false;
        for (var i = 0; i < previewCasesEls.length; i++) {
          var slot = previewCasesEls[i];
          var entry = alloc[i];
          if (!entry || !entry.colorName || !size) {
            slot.classList.add('tw:hidden');
            slot.classList.remove('tw:flex');
            setPreviewLidText(slot, '');
            continue;
          }
          var variant = findCaseVariant(size, entry.colorName);
          var src = getCasePreviewImageSrc(variant);
          if (!src) {
            slot.classList.add('tw:hidden');
            slot.classList.remove('tw:flex');
            setPreviewLidText(slot, '');
            continue;
          }
          var imgEl = slot.querySelector('img');
          if (imgEl && imgEl.getAttribute('src') !== src) imgEl.setAttribute('src', src);
          setPreviewLidText(slot, getPreviewLidText(detail, i));
          slot.classList.remove('tw:hidden');
          slot.classList.add('tw:flex');
          paintedAny = true;
        }

        if (previewInitEl) previewInitEl.classList.toggle('tw:opacity-0', paintedAny);
      }
    }

    function renderSpecAccordionSize(size) {
      var pocketCount = parseInt(pickerState.pocketCount, 10) || 0;
      var sizeData = specSizePocketCount === pocketCount && size ? getSizeData(size) : null;
      var caseSpecsSizeKey = sizeData ? toLookupKey(sizeData.case_specs_size) : '';
      var prefill = pickerState.urlPrefill;
      var hideForUnresolvedUrlSize = !!(prefill && prefill.hasSize
        && (prefill.sizeStatus === 'pending' || prefill.sizeStatus === 'unknown'));
      var matched = false;

      for (var i = 0; i < specPanelEls.length; i++) {
        var panel = specPanelEls[i];
        var panelPocketCount = parseInt(panel.getAttribute('data-magnano-case-spec-pocket-count'), 10) || 0;
        var panelSizeKey = panel.getAttribute('data-magnano-case-spec-size-key') || '';
        var isSelectedSize = caseSpecsSizeKey !== '' && panelSizeKey === caseSpecsSizeKey;
        var isDefaultSize = caseSpecsSizeKey === '' && panel.hasAttribute('data-magnano-case-spec-default');
        var show = !hideForUnresolvedUrlSize && pocketCount > 0 && panelPocketCount === pocketCount
          && (isSelectedSize || isDefaultSize);
        panel.classList.toggle('tw:hidden', !show);
        if (show) matched = true;
      }

      if (specAccordionEl) {
        specAccordionEl.classList.toggle('tw:hidden', !matched);
        specAccordionEl.classList.toggle('tw:flex', matched);
      }
    }

    function attachGallerySwipe() {
      if (!galleryStageEl) return;
      var startX = 0;
      var startY = 0;
      var tracking = false;
      galleryStageEl.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches[0]) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });
      galleryStageEl.addEventListener('touchend', function (e) {
        if (!tracking || !e.changedTouches || !e.changedTouches[0]) return;
        tracking = false;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) < 50) return;
        if (Math.abs(dy) > Math.abs(dx)) return;
        if (dx < 0) setActiveSlide(activeSlideIndex + 1);
        else setActiveSlide(activeSlideIndex - 1);
      }, { passive: true });
    }

    function renderPdpPriceStock(detail) {
      if (priceBlockEl && pricePromptEl && priceFigureEl) {
        var totals = (detail && detail.totals) || { totalCents: 0, hasPriceBasis: false };
        if (totals.hasPriceBasis) {
          pricePromptEl.classList.add('tw:hidden');
          priceFigureEl.classList.remove('tw:hidden');
          if (priceTotalEl) priceTotalEl.textContent = formatMoneySafe(totals.totalCents);
        } else {
          pricePromptEl.classList.remove('tw:hidden');
          priceFigureEl.classList.add('tw:hidden');
        }
      }
      if (stockPillEl && stockLabelEl) {
        var status = 'instock';
        var size = detail && detail.size;
        if (size) {
          var sizeData = getSizeData(size);
          if (sizeData && isSizeUnavailable(sizeData)) {
            status = 'outstock';
          } else if (detail && detail.colorsConfirmed) {
            status = detail.preorder && detail.preorder.hasPreorder ? 'preorder' : 'instock';
          }
        }
        stockPillEl.setAttribute('data-stock-status', status);
        var labelKey = status === 'outstock' ? 'data-out' : (status === 'preorder' ? 'data-pre' : (status === 'instock' ? 'data-in' : ''));
        stockLabelEl.textContent = labelKey ? (stockPillEl.getAttribute(labelKey) || '') : '';
        if (stockEtaEl) {
          var preorderEta = status === 'preorder' && detail && detail.preorder ? detail.preorder.eta : '';
          stockEtaEl.textContent = preorderEta || '';
          stockEtaEl.hidden = !preorderEta;
        }
      }
    }

    function dispatchStateEvent() {
      var packCount = pickerState.packCount || 0;
      var tier = packCount > 0
        ? findTierVariant(packCount, pickerState.pocketCount, pickerState.size)
        : null;
      var alloc = pickerState.colorAllocation || [];
      var detail = {
        pocketCount: pickerState.pocketCount || null,
        caseProductHandle: getDispatchProductHandle(pickerState.dispatchEntry) || null,
        size: pickerState.size || null,
        packCount: packCount || null,
        colorAllocation: alloc.map(function (e, i) {
          if (!e) return { slotIndex: i, variantId: null, colorName: null };
          return { slotIndex: i, variantId: e.variantId || null, colorName: e.colorName || null };
        }),
        lidEngraving: {
          mode: (pickerState.lidEngraving && pickerState.lidEngraving.mode) || 'NONE',
          labels: ((pickerState.lidEngraving && pickerState.lidEngraving.labels) || []).slice()
        },
        pocketEngraving: {
          mode: (pickerState.pocketEngraving && pickerState.pocketEngraving.mode) || 'NONE',
          labels: ((pickerState.pocketEngraving && pickerState.pocketEngraving.labels) || []).slice(),
          dotwSync: !!(pickerState.pocketEngraving && pickerState.pocketEngraving.dotwSync)
        },
        travelSelected: (pickerState.travelBox && pickerState.travelBox.selected && isTravelVariantAvailable()) ? 'yes' : 'no',
        tierVariantId: tier ? String(tier.id) : null,
        addonVariantIds: {
          lid: lidVariant ? String(lidVariant.id) : null,
          pocket: pocketVariant ? String(pocketVariant.id) : null,
          travel: isTravelVariantAvailable() ? String(travelVariant.id) : null
        },
        totals: computePresentmentTotals(),
        colorsConfirmed: !!(pickerState.touchedSteps && pickerState.touchedSteps['4']),
        preorder: computePreorderState(true),
        expandedStep: pickerState.expandedStep || '',
        isAtcReady: typeof isAtcReady === 'function' ? !!isAtcReady() : false
      };
      section.dispatchEvent(new CustomEvent('magnano-v2:state', { detail: detail }));
    }

    function refreshAtc() {
      if (!atcBtn) return;
      setAtcSpinner(false);
      var payload = isAtcReady() ? buildPayload() : null;
      if (!payload) {
        atcBtn.disabled = true;
        setAtcLabel('Configure Your Case First');
      } else {
        atcBtn.disabled = false;
        setAtcLabel('Add to Cart');
      }
      dispatchStateEvent();
    }

    function setAtcDisabled(reason) {
      if (!atcBtn) return;
      setAtcSpinner(false);
      atcBtn.disabled = true;
      setAtcLabel('Configure Your Case First');
    }

    function findDispatchEntry(pc) {
      if (!dispatchList) return null;
      return dispatchList.find(function (e) { return e.pocketCount === pc; }) || null;
    }

    function parseMagnanoCartReservationPayload(value) {
      if (!value) return null;
      try {
        var parsed = JSON.parse(value);
        return parsed && Array.isArray(parsed.c) ? parsed.c : null;
      } catch (err) {
        return null;
      }
    }

    function addCartReservation(variantId, quantity) {
      var id = String(variantId || '');
      var qty = parseInt(quantity, 10) || 0;
      if (!id || qty < 1) return;
      cartReservedByVariantId[id] = (cartReservedByVariantId[id] || 0) + qty;
    }

    function fetchCartReservations() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (resp) {
          if (!resp.ok) throw new Error('HTTP ' + resp.status);
          return resp.json();
        })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          cartReservedByVariantId = {};
          cart.items.forEach(function (item) {
            var quantity = parseInt(item.quantity, 10) || 0;
            var properties = item.properties || {};
            var magnanoCaseIds = parseMagnanoCartReservationPayload(properties._magnano);
            if (magnanoCaseIds && magnanoCaseIds.length) {
              magnanoCaseIds.forEach(function (caseId) { addCartReservation(caseId, quantity); });
              return;
            }
            addCartReservation(item.variant_id || item.id, quantity);
          });
          if (pickerState.expandedStep === '3') renderPackCountSlots();
          if (pickerState.expandedStep === '4') refreshColorOptions();
          if (pickerState.size) refreshTravelState();
          dispatchStateEvent();
        })
        .catch(function (err) {
          console.warn('[magnano-v2] /cart.js fetch failed; cart-reserved subtraction skipped:', err);
        })
        .then(function () {
          cartReservationsLoaded = true;
        });
    }

    function init() {
      tierProduct = readInlineJson('magnano-v2-tier-' + SECTION_ID);
      dispatchList = readInlineJson('magnano-v2-dispatch-' + SECTION_ID);
      lidProduct = readInlineJson('magnano-v2-lid-' + SECTION_ID);
      pocketProduct = readInlineJson('magnano-v2-pocket-' + SECTION_ID);
      travelProduct = readInlineJson('magnano-v2-travel-' + SECTION_ID);
      applyTravelInventory(readInlineJson('magnano-v2-travel-inventory-' + SECTION_ID));

      if (!tierProduct) { console.warn('[magnano-v2] Missing tier product. Set shop.metafields.custom.magnano_tier_product.'); return; }
      if (!dispatchList) { console.warn('[magnano-v2] Missing dispatch list.'); return; }

      pickerState.urlPrefill = parseUrlPrefill();
      if (pickerState.urlPrefill) {
        setUrlPrefillStatus('pockets', pickerState.urlPrefill.pocketStatus);
        setUrlPrefillStatus('size', pickerState.urlPrefill.sizeStatus);
        setUrlPrefillStatus('color', pickerState.urlPrefill.colorStatus);
      }

      var d8Entry = dispatchList.find(function (e) { return e.handle === currentHandle; });
      if (!d8Entry) { d8Entry = dispatchList.find(function (e) { return e.pocketCount === 1; }) || dispatchList[0]; }
      if (!d8Entry) { console.warn('[magnano-v2] No dispatch entries at all. Aborting.'); return; }

      if (pickerState.urlPrefill && pickerState.urlPrefill.hasPockets) {
        var pocketPrefill = resolvePocketPrefill(pickerState.urlPrefill);
        setUrlPrefillStatus('pockets', pocketPrefill.status);
        if (pocketPrefill.status === 'valid') {
          d8Entry = pocketPrefill.entry;
        } else {
          setPocketCountValidationMessage('Requested pocket count ' + requestedValueLabel(pickerState.urlPrefill.rawPockets) + ' is not available. Please choose an available pocket count.');
        }
      }

      pickerState.pocketCount = d8Entry.pocketCount;
      pickerState.dispatchEntry = d8Entry;
      setPdpTitle(d8Entry.title);
      setPdpReviews(d8Entry.pocketCount);

      renderPocketSlots();
      setStepSummary('1', d8Entry.pocketCount + '-Pocket');
      applyStepVisualState('1');
      setStepLocked('2', true);

      setStepLocked('3', true);
      setStepLocked('4', true);
      setStepLocked('5', true);
      setStepLocked('6', true);
      setStepLocked('7', true);
      normalizePocketMode();
      applyLidModeVisual();
      applyPocketModeVisual();
      applyTravelVisual();
      setAtcDisabled('Pick a size and confirm step 2 to load the test bundle');
      cartReservationsPromise = fetchCartReservations();
      if (!applyUrlPrefill()) fetchSelectedCaseProduct(false);

      var packPopup = section.querySelector('[data-pack-popup]');
      if (packPopup) {
        packPopup.addEventListener('beforetoggle', onPopupBeforeToggle);
        packPopup.addEventListener('toggle', onPopupToggle);
      }

      section.addEventListener('magnano-v2:state', function (e) { renderPdpPriceStock(e.detail); });
      section.addEventListener('magnano-v2:state', function (e) { renderCompositePreview(e.detail); });
      section.addEventListener('magnano-v2:state', function (e) { renderSpecAccordionSize(e.detail && e.detail.size); });
      section.addEventListener('magnano-v2:state', function (e) {
        syncDetailsSectionForDispatchEntry(pickerState.dispatchEntry, e.detail && e.detail.size, { initial: !detailsInitialStateHandled });
        detailsInitialStateHandled = true;
      });

      attachGallerySwipe();
      setActiveSlide(activeSlideIndex);
      dispatchStateEvent();
    }

    section.addEventListener('change', function (e) {
      var notifyPocket = e.target.closest('[data-notify-pocket-count]');
      if (notifyPocket && section.contains(notifyPocket)) { setNotifyMessage('', 'neutral'); refreshNotifySizeOptions('', ''); return; }
      var notifySize = e.target.closest('[data-notify-size]');
      if (notifySize && section.contains(notifySize)) { setNotifyMessage('', 'neutral'); refreshNotifyColorOptions(''); return; }
      var notifyColor = e.target.closest('[data-notify-color]');
      if (notifyColor && section.contains(notifyColor)) { setNotifyMessage('', 'neutral'); syncNotifyHiddenFields(); return; }
      var lidSel = e.target.closest('[data-lid-day-select]');
      if (lidSel && section.contains(lidSel)) { onLidDayChange(lidSel); return; }
      var pocketSyncBox = e.target.closest('[data-pocket-dotw-sync]');
      if (pocketSyncBox && section.contains(pocketSyncBox)) { onPocketDotwSyncChange(pocketSyncBox); return; }
      var pocketDaySel = e.target.closest('[data-pocket-day-select]');
      if (pocketDaySel && section.contains(pocketDaySel)) { onPocketDaySelectChange(pocketDaySel); return; }
    });

    section.addEventListener('input', function (e) {
      var notifyEmail = e.target.closest('[data-notify-email]');
      if (notifyEmail && section.contains(notifyEmail)) { setNotifyMessage('', 'neutral'); return; }
      var lidInput = e.target.closest('[data-lid-custom-input]');
      if (lidInput && section.contains(lidInput)) { onLidCustomInput(lidInput); return; }
      var pocketInput = e.target.closest('[data-pocket-custom-input]');
      if (pocketInput && section.contains(pocketInput)) { onPocketCustomInput(pocketInput); return; }
    });

    section.addEventListener('pointerdown', function (e) {
      if (!e.target || typeof e.target.closest !== 'function') return;
      var trigger = e.target.closest('[popovertarget]');
      if (trigger && section.contains(trigger)) preparePopupFromTrigger(trigger);
    }, true);

    section.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && notifyModalEl && notifyModalEl.getAttribute('data-open') === 'true') {
        closeNotifyModal();
        return;
      }
      if (e.key !== 'Enter' && e.key !== ' ') return;
      if (!e.target || typeof e.target.closest !== 'function') return;
      var trigger = e.target.closest('[popovertarget]');
      if (trigger && section.contains(trigger)) preparePopupFromTrigger(trigger);
    }, true);

    section.addEventListener('click', function (e) {
      var notifyOpen = e.target.closest('[data-notify-open]');
      if (notifyOpen && section.contains(notifyOpen)) { e.preventDefault(); openNotifyModal(); return; }
      var notifyClose = e.target.closest('[data-notify-close]');
      if (notifyClose && section.contains(notifyClose)) { e.preventDefault(); closeNotifyModal(); return; }
      if (notifyModalEl && e.target === notifyModalEl) { closeNotifyModal(); return; }
      var compareTrigger = e.target.closest('[data-compare-tooltip]');
      if (compareTrigger && section.contains(compareTrigger)) {
        e.preventDefault();
        e.stopPropagation();
        toggleCompareTooltip(compareTrigger);
        return;
      }
      var galleryNav = e.target.closest('[data-gallery-nav]');
      if (galleryNav && section.contains(galleryNav)) { e.preventDefault(); onGalleryNavClick(galleryNav); return; }
      var galleryThumb = e.target.closest('[data-gallery-thumb]');
      if (galleryThumb && section.contains(galleryThumb)) { onGalleryThumbClick(galleryThumb); return; }
      var slot = e.target.closest('[data-pocket-slot]');
      if (slot && section.contains(slot)) { onPocketSlotClick(slot); return; }
      var sizeRow = e.target.closest('[data-size-row]');
      if (sizeRow && section.contains(sizeRow)) { onSizeRowClick(sizeRow); return; }
      var step2Retry = e.target.closest('[data-step-error-retry="2"]');
      if (step2Retry && section.contains(step2Retry)) { e.preventDefault(); onStep2Expand(true); return; }
      var packOption = e.target.closest('[data-pack-option]');
      if (packOption && section.contains(packOption)) { onPackOptionClick(packOption); return; }
      var colorOption = e.target.closest('[data-color-option]');
      if (colorOption && section.contains(colorOption)) { onColorOptionClick(colorOption); return; }
      var lidModeBtn = e.target.closest('[data-lid-mode]');
      if (lidModeBtn && section.contains(lidModeBtn)) { onLidModeClick(lidModeBtn); return; }
      var pocketModeBtn = e.target.closest('[data-pocket-mode]');
      if (pocketModeBtn && section.contains(pocketModeBtn)) { onPocketModeClick(pocketModeBtn); return; }
      var travelOptionBtn = e.target.closest('[data-travel-option]');
      if (travelOptionBtn && section.contains(travelOptionBtn)) { onTravelOptionClick(travelOptionBtn); return; }
      var confirmBtn = e.target.closest('[data-step-confirm]');
      if (confirmBtn && section.contains(confirmBtn)) { e.preventDefault(); onStepConfirmClick(confirmBtn); return; }
      var header = e.target.closest('[data-step-header]');
      if (header && section.contains(header)) { e.preventDefault(); onStepHeaderClick(header); return; }
      if (e.target === atcBtn || (atcBtn && atcBtn.contains(e.target))) { onAtcClick(); return; }
    });

    if (notifyFormEl) {
      notifyFormEl.addEventListener('submit', onNotifySubmit);
    }

    document.addEventListener('click', function (e) {
      if (currentTooltip && !e.target.closest('[data-compare-tooltip], .dynamic-tooltip')) {
        closeCompareTooltip();
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
